
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hMnGK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("kbjJh")).TeamDashboardSidebar);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $kbjJh = parcelRequire("kbjJh");

});
parcelRegister("kbjJh", function(module, exports) {

$parcel$export(module.exports, "TeamDashboardSidebar", () => $ad9bf789d7483b88$export$3c52ba4eab589d74);

var $5uXOq = parcelRequire("5uXOq");

var $2V88h = parcelRequire("2V88h");

var $1Ucx1 = parcelRequire("1Ucx1");

var $2WDJ4 = parcelRequire("2WDJ4");

var $kHbhJ = parcelRequire("kHbhJ");

var $dF4Di = parcelRequire("dF4Di");

var $5Hj3V = parcelRequire("5Hj3V");

var $fobme = parcelRequire("fobme");

var $acDan = parcelRequire("acDan");

var $8zOmE = parcelRequire("8zOmE");
const $ad9bf789d7483b88$export$3c52ba4eab589d74 = ()=>{
    const { openEocFeedbackCollector: openEocFeedbackCollector } = (0, $1Ucx1.useEocFeedbackCollector)();
    const onFeedbackButtonClick = (_, analyticEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticEvent, 'eocGiveFeedbackButton');
        openEocFeedbackCollector();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Hj3V.SidebarErrorBoundary), {
        teamName: "alexstrasza",
        packageName: "jiraNavigationAppsSidebarEocTeamDashboard",
        id: "jiraNavigationAppsSidebarEocTeamDashboardSidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2WDJ4.GlobalContextContainer), {
        teamName: "alexstrasza",
        packageName: "jiraEocTeamDashboard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dF4Di.ConsolidatedStateWrapper), {
        errorComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHbhJ.ConsolidatedStateError), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2V88h.Sidebar), {
        onFeedbackButtonClick: onFeedbackButtonClick
    })))), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarReady), {
        id: (0, $fobme.SIDEBAR_ID).EOC_OPERATIONS
    }));
};

});
parcelRegister("2V88h", function(module, exports) {

$parcel$export(module.exports, "Sidebar", () => $ee5d9dfcbf56871f$export$1ba59dacbcbf90fe);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bmKPg = parcelRequire("bmKPg");
var $doZTA = parcelRequire("doZTA");

var $fVnbM = parcelRequire("fVnbM");

var $4ldhu = parcelRequire("4ldhu");

var $kaa7g = parcelRequire("kaa7g");

var $6w2oK = parcelRequire("6w2oK");

var $8vDvO = parcelRequire("8vDvO");

var $d1ABl = parcelRequire("d1ABl");

var $aEHvW = parcelRequire("aEHvW");

var $4hqZ5 = parcelRequire("4hqZ5");

var $jOrGg = parcelRequire("jOrGg");

var $fyC9a = parcelRequire("fyC9a");

var $jDorM = parcelRequire("jDorM");

var $hOz5f = parcelRequire("hOz5f");

var $6mI6x = parcelRequire("6mI6x");

var $4WNKY = parcelRequire("4WNKY");

var $2qHz8 = parcelRequire("2qHz8");

var $707IR = parcelRequire("707IR");

var $b2Hwm = parcelRequire("b2Hwm");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $fNobW = parcelRequire("fNobW");

var $jSfqD = parcelRequire("jSfqD");
var $jASxh = parcelRequire("jASxh");
var $2hFr5 = parcelRequire("2hFr5");
var $4PB4I = parcelRequire("4PB4I");
var $g2EiV = parcelRequire("g2EiV");
var $9btdk = parcelRequire("9btdk");
var $8UO8z = parcelRequire("8UO8z");
var $gjTBi = parcelRequire("gjTBi");
var $gZEU1 = parcelRequire("gZEU1");
var $bWqXX = parcelRequire("bWqXX");

var $jSRx6 = parcelRequire("jSRx6");

var $gIuON = parcelRequire("gIuON");

var $3mHCV = parcelRequire("3mHCV");

var $hem2I = parcelRequire("hem2I");

var $cbdUv = parcelRequire("cbdUv");

var $3pkeM = parcelRequire("3pkeM");

var $2r8fH = parcelRequire("2r8fH");

var $cxmrp = parcelRequire("cxmrp");

var $bvdmP = parcelRequire("bvdmP");

var $4Vb0Z = parcelRequire("4Vb0Z");
const $ee5d9dfcbf56871f$export$1ba59dacbcbf90fe = ({ onFeedbackButtonClick: onFeedbackButtonClick })=>{
    const [{ location: location }] = (0, $doZTA.useRouter)();
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: sidebarRights, loading: loading } = (0, $hem2I.default)((0, $2r8fH.sidebarRightsResource));
    const routeItems = (0, $5uXOq.useMemo)(()=>({
            alerts: `/jira/ops/teams/${teamId}/alerts?query=responders: ${teamId}`,
            onCall: `/jira/ops/teams/${teamId}/on-call`,
            reports: `/jira/ops/teams/${teamId}/reports`,
            integrations: `/jira/ops/teams/${teamId}/integrations`,
            policies: `/jira/ops/teams/${teamId}/policies`,
            automations: `/jira/ops/teams/${teamId}/automations`,
            alertIssueSyncing: `/jira/ops/teams/${teamId}/syncs`,
            settings: `/jira/ops/teams/${teamId}/settings`,
            heartbeats: `/jira/ops/teams/${teamId}/heartbeats`,
            maintenance: `/jira/ops/teams/${teamId}/maintenance`
        }), [
        teamId
    ]);
    const initialStackId = (0, $5uXOq.useMemo)(()=>{
        const nestedRoutes = [
            'alerts'
        ];
        if (sidebarRights?.showReports) nestedRoutes.push('reports');
        const currentRoute = Object.entries(routeItems).find(([key, value])=>location.pathname.includes(value.split('?')[0]));
        if (currentRoute) {
            const [currentRouteId] = currentRoute;
            if (nestedRoutes.includes(currentRouteId)) return [
                currentRouteId
            ];
        }
        return [];
    }, [
        location.pathname,
        routeItems,
        sidebarRights?.showReports
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "eoc-team-dashboard-sidebar-rights-loading",
        hold: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZEU1.default), {
        label: formatMessage((0, $bvdmP.default).sidebarLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g2EiV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cxmrp.Header), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9btdk.default), {
        initialStack: initialStackId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2hFr5.default), {
        isLoading: (0, $gIuON.isServer)() || loading,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
            hasIcon: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
            hasIcon: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
            hasIcon: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
            hasIcon: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
            hasIcon: true
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $cbdUv.SPOTLIGHT_NAMES).sidebarItems
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Vb0Z.SectionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8UO8z.default), {
        analyticsItemId: "eocAlerts",
        component: (0, $3pkeM.Link),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jDorM))), {
            color: "currentColor",
            LEGACY_fallbackIcon: (0, $6mI6x.default),
            label: ''
        }),
        to: routeItems['alerts'],
        id: "alerts",
        title: formatMessage((0, $bvdmP.default).alerts),
        isSelected: location.pathname.includes(routeItems['alerts'])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSRx6.SavedSearches), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSfqD.default), {
        analyticsItemId: "eocOnCall",
        component: (0, $3pkeM.Link),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hOz5f))), {
            label: "",
            LEGACY_fallbackIcon: (0, $707IR.default),
            color: "currentColor"
        }),
        to: routeItems['onCall'],
        id: "onCall",
        isSelected: location.pathname.includes(routeItems['onCall'])
    }, formatMessage((0, $bvdmP.default).onCall))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSfqD.default), {
        analyticsItemId: "eocIntegrations",
        component: (0, $3pkeM.Link),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vDvO))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }),
        to: routeItems['integrations'],
        id: "integrations",
        isSelected: location.pathname.includes(routeItems['integrations'])
    }, formatMessage((0, $bvdmP.default).integrations)), sidebarRights?.showAutomation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSfqD.default), {
        analyticsItemId: "eocAutomations",
        component: (0, $3pkeM.Link),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
            LEGACY_fallbackIcon: (0, $4WNKY.default),
            label: "",
            color: "currentColor"
        }),
        to: routeItems['automations'],
        id: "automation",
        isSelected: location.pathname.includes(routeItems['automations'])
    }, formatMessage((0, $bvdmP.default).automations)), sidebarRights?.showSync && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSfqD.default), {
        analyticsItemId: "eocAlertIssueSyncing",
        component: (0, $3pkeM.Link),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOrGg))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }),
        to: routeItems['alertIssueSyncing'],
        id: "alertIssueSyncing",
        isSelected: location.pathname.includes(routeItems['alertIssueSyncing'])
    }, formatMessage((0, $bvdmP.default).alertIssueSyncing)), sidebarRights?.showHeartbeats && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSfqD.default), {
        analyticsItemId: "eocHeartbeats",
        component: (0, $3pkeM.Link),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6w2oK))), {
            LEGACY_fallbackIcon: (0, $2qHz8.default),
            label: "",
            color: "currentColor"
        }),
        to: routeItems['heartbeats'],
        id: "heartbeats",
        isSelected: location.pathname.includes(routeItems['heartbeats'])
    }, formatMessage((0, $bvdmP.default).heartbeats))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSfqD.default), {
        analyticsItemId: "eocMaintenance",
        component: (0, $3pkeM.Link),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fyC9a))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }),
        to: routeItems['maintenance'],
        id: "maintenance",
        isSelected: location.pathname.includes(routeItems['maintenance'])
    }, formatMessage((0, $bvdmP.default).maintenance)), sidebarRights?.showPolicies && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSfqD.default), {
        analyticsItemId: "eocPolicies",
        component: (0, $3pkeM.Link),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kaa7g))), {
            LEGACY_fallbackIcon: (0, $b2Hwm.default),
            label: "",
            color: "currentColor"
        }),
        to: routeItems['policies'],
        id: "policies",
        isSelected: location.pathname.includes(routeItems['policies'])
    }, formatMessage((0, $bvdmP.default).policies))), sidebarRights?.showReports && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: sidebarRights?.showMembers
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8UO8z.default), {
        analyticsItemId: "eocReports",
        component: (0, $3pkeM.Link),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d1ABl))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }),
        to: routeItems['reports'],
        id: "reports",
        title: formatMessage((0, $bvdmP.default).reports),
        isSelected: location.pathname.includes(routeItems['reports'])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mHCV.Sidebar), {
        baseRoute: `/jira/ops/teams/${teamId}/reports`
    }))), sidebarRights?.showMembers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSfqD.default), {
        analyticsItemId: "eocSettings",
        component: (0, $3pkeM.Link),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
            color: "currentColor",
            spacing: "spacious",
            label: formatMessage((0, $bvdmP.default).settings)
        }),
        to: routeItems['settings'],
        id: "settings",
        isSelected: location.pathname.includes(routeItems['settings'])
    }, formatMessage((0, $bvdmP.default).settings))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4PB4I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jASxh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aEHvW))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "small"
        }),
        onClick: onFeedbackButtonClick
    }, formatMessage((0, $bvdmP.default).giveFeedbackButton))))));
};

});
parcelRegister("4ldhu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f63c4f2736d56f4b2fa41b3195f28f63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32936cf628dec798$var$_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $32936cf628dec798$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32936cf628dec798$var$AutomationIcon = (props)=>/*#__PURE__*/ $32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6 15.25-.723-.2a.75.75 0 0 0 1.253.73zM13.25 8l.53.53a.75.75 0 0 0-.53-1.28zM10 .75l.723.2A.75.75 0 0 0 9.47.22zM2.75 8l-.53-.53a.75.75 0 0 0 .53 1.28zm3.78 7.78 7.25-7.25-1.06-1.06-7.25 7.25zm6.72-8.53H8v1.5h5.25zm-4.527.95 2-7.25-1.446-.4-2 7.25zM9.47.22 2.22 7.47l1.06 1.06 7.25-7.25zM2.75 8.75H8v-1.5H2.75zm4.527-.95-2 7.25 1.446.4 2-7.25z"/>`
    }, props));
$32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;

});

parcelRegister("kaa7g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0147e65f1c51fb4c0e3ff0e9a45c092c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eadc96b253df8830$var$_react = $eadc96b253df8830$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eadc96b253df8830$var$_baseNew = $eadc96b253df8830$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eadc96b253df8830$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eadc96b253df8830$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $eadc96b253df8830$var$_react.default.createElement($eadc96b253df8830$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 8.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V8.75m-12.5 0V6c0-.69.56-1.25 1.25-1.25h1.75m-3 4H8m6.25 0V6c0-.69-.56-1.25-1.25-1.25h-1.75m3 4H8m0 0V11M4.75 4.75V3c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v1.75m-6.5 0h6.5"/>`
    }, props));
$eadc96b253df8830$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
var $eadc96b253df8830$var$_default = module.exports.default = $eadc96b253df8830$var$BriefcaseIcon;

});

parcelRegister("6w2oK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fef76b73c3b9e01ac4d8d8c0930a2de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4be79778c543f14f$var$_react = $4be79778c543f14f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4be79778c543f14f$var$_baseNew = $4be79778c543f14f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $4be79778c543f14f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Heart".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: emoji symbols in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4be79778c543f14f$var$HeartIcon = (props)=>/*#__PURE__*/ $4be79778c543f14f$var$_react.default.createElement($4be79778c543f14f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 14.5a.6.6 0 0 1-.245-.061 1.5 1.5 0 0 1-.244-.123q-1.917-1.225-3.324-2.567-1.408-1.348-2.176-2.764-.76-1.422-.761-2.873 0-.905.286-1.654.291-.756.808-1.307A3.6 3.6 0 0 1 5.036 2q1 0 1.754.51.754.511 1.21 1.349A3.76 3.76 0 0 1 9.217 2.51Q9.97 2 10.964 2q.801 0 1.488.3.694.3 1.204.85.516.552.802 1.308.292.749.292 1.654 0 1.45-.768 2.873-.761 1.416-2.169 2.765-1.4 1.342-3.317 2.566a1.4 1.4 0 0 1-.251.123A.6.6 0 0 1 8 14.5Z"/>`
    }, props));
$4be79778c543f14f$var$HeartIcon.displayName = 'HeartIcon';
var $4be79778c543f14f$var$_default = module.exports.default = $4be79778c543f14f$var$HeartIcon;

});

parcelRegister("d1ABl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3d92fed5a956f7f7b093cb4ccc85cf73>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97b7c29ceb1a6bc1$var$_react = $97b7c29ceb1a6bc1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $97b7c29ceb1a6bc1$var$_chartBar = $97b7c29ceb1a6bc1$var$_interopRequireDefault((parcelRequire("fDskX")));

var $97b7c29ceb1a6bc1$var$_graphBar = $97b7c29ceb1a6bc1$var$_interopRequireDefault((parcelRequire("iLAWO")));
function $97b7c29ceb1a6bc1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChartBarIcon.
 * This component is ChartBarIcon, with `UNSAFE_fallbackIcon` set to "GraphBarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97b7c29ceb1a6bc1$var$ChartBarIcon = (props)=>/*#__PURE__*/ $97b7c29ceb1a6bc1$var$_react.default.createElement($97b7c29ceb1a6bc1$var$_chartBar.default, Object.assign({
        LEGACY_fallbackIcon: $97b7c29ceb1a6bc1$var$_graphBar.default
    }, props));
$97b7c29ceb1a6bc1$var$ChartBarIcon.Name = 'ChartBarIconMigration';
var $97b7c29ceb1a6bc1$var$_default = module.exports.default = $97b7c29ceb1a6bc1$var$ChartBarIcon;

});
parcelRegister("fDskX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d3ac0915bdeb94dd7c93af5baf915b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6207aa8debd29f4$var$_react = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b6207aa8debd29f4$var$_baseNew = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b6207aa8debd29f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6207aa8debd29f4$var$ChartBarIcon = (props)=>/*#__PURE__*/ $b6207aa8debd29f4$var$_react.default.createElement($b6207aa8debd29f4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.917 9.75H1.75V13c0 .69.56 1.25 1.25 1.25h2.917m0-4.5v4.5m0-4.5v-4h4.166m-4.166 8.5h4.166m0-8.5v-4h4.167V13c0 .69-.56 1.25-1.25 1.25h-2.917m0-8.5v8.5"/>`
    }, props));
$b6207aa8debd29f4$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $b6207aa8debd29f4$var$_default = module.exports.default = $b6207aa8debd29f4$var$ChartBarIcon;

});

parcelRegister("iLAWO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $da9946d1fc4faefc$var$_react = $da9946d1fc4faefc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $da9946d1fc4faefc$var$_chartBar = $da9946d1fc4faefc$var$_interopRequireDefault((parcelRequire("fDskX")));
function $da9946d1fc4faefc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $da9946d1fc4faefc$var$GraphBarIcon = (props)=>/*#__PURE__*/ $da9946d1fc4faefc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="4" height="11" x="17" y="5" rx="2"/><rect width="4" height="8" x="11" y="8" rx="2"/><rect width="4" height="5" x="5" y="11" rx="2"/><path fill-rule="nonzero" d="M21 17H4.995C4.448 17 4 16.548 4 15.991V6a1 1 0 1 0-2 0v9.991A3.004 3.004 0 0 0 4.995 19H21a1 1 0 0 0 0-2"/></g></svg>`
    }, props, {
        newIcon: $da9946d1fc4faefc$var$_chartBar.default
    }));
$da9946d1fc4faefc$var$GraphBarIcon.displayName = 'GraphBarIcon';
var $da9946d1fc4faefc$var$_default = module.exports.default = $da9946d1fc4faefc$var$GraphBarIcon;

});


parcelRegister("aEHvW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06b2b9eec310f6566d6d86916ad7e234>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));

var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
    }, props));
$7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;

});
parcelRegister("5dqGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cdeb4e8fedeb21cdc8d38f736eb852b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cc2df171aca9493$var$_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3cc2df171aca9493$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cc2df171aca9493$var$FeedbackIcon = (props)=>/*#__PURE__*/ $3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
    }, props));
$3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;

});

parcelRegister("3g1Fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>/*#__PURE__*/ $25f4287f17f73dc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $25f4287f17f73dc4$var$_feedback.default
    }));
$25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;

});


parcelRegister("jOrGg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e77e094a0aa1d7ca1d4c9b1f496feee5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6c828a42ee64c30$var$_react = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6c828a42ee64c30$var$_refresh = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("gPelT")));

var $e6c828a42ee64c30$var$_refresh2 = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("75Jbm")));
function $e6c828a42ee64c30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for RefreshIcon.
 * This component is RefreshIcon, with `UNSAFE_fallbackIcon` set to "RefreshIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6c828a42ee64c30$var$RefreshIcon = (props)=>/*#__PURE__*/ $e6c828a42ee64c30$var$_react.default.createElement($e6c828a42ee64c30$var$_refresh.default, Object.assign({
        LEGACY_fallbackIcon: $e6c828a42ee64c30$var$_refresh2.default
    }, props));
$e6c828a42ee64c30$var$RefreshIcon.Name = 'RefreshIconMigration';
var $e6c828a42ee64c30$var$_default = module.exports.default = $e6c828a42ee64c30$var$RefreshIcon;

});
parcelRegister("gPelT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f34e41ee33b1e524435b178556b66735>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3fc8ad083e2745c$var$_react = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c3fc8ad083e2745c$var$_baseNew = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c3fc8ad083e2745c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3fc8ad083e2745c$var$RefreshIcon = (props)=>/*#__PURE__*/ $c3fc8ad083e2745c$var$_react.default.createElement($c3fc8ad083e2745c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
    }, props));
$c3fc8ad083e2745c$var$RefreshIcon.displayName = 'RefreshIcon';
var $c3fc8ad083e2745c$var$_default = module.exports.default = $c3fc8ad083e2745c$var$RefreshIcon;

});

parcelRegister("75Jbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $529c0c456318696f$var$_react = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $529c0c456318696f$var$_refresh = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("gPelT")));
function $529c0c456318696f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $529c0c456318696f$var$RefreshIcon = (props)=>/*#__PURE__*/ $529c0c456318696f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $529c0c456318696f$var$_refresh.default
    }));
$529c0c456318696f$var$RefreshIcon.displayName = 'RefreshIcon';
var $529c0c456318696f$var$_default = module.exports.default = $529c0c456318696f$var$RefreshIcon;

});


parcelRegister("fyC9a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bef99f1a2edb80cb2c217355be84450e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5379f2924fc9e12$var$_react = $b5379f2924fc9e12$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b5379f2924fc9e12$var$_stopwatch = $b5379f2924fc9e12$var$_interopRequireDefault((parcelRequire("cXVn2")));

var $b5379f2924fc9e12$var$_stopwatch2 = $b5379f2924fc9e12$var$_interopRequireDefault((parcelRequire("63gsv")));
function $b5379f2924fc9e12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for StopwatchIcon.
 * This component is StopwatchIcon, with `UNSAFE_fallbackIcon` set to "StopwatchIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5379f2924fc9e12$var$StopwatchIcon = (props)=>/*#__PURE__*/ $b5379f2924fc9e12$var$_react.default.createElement($b5379f2924fc9e12$var$_stopwatch.default, Object.assign({
        LEGACY_fallbackIcon: $b5379f2924fc9e12$var$_stopwatch2.default
    }, props));
$b5379f2924fc9e12$var$StopwatchIcon.Name = 'StopwatchIconMigration';
var $b5379f2924fc9e12$var$_default = module.exports.default = $b5379f2924fc9e12$var$StopwatchIcon;

});
parcelRegister("cXVn2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c09c63acd06b5465ead792de36bbf854>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97077f52e189c3c9$var$_react = $97077f52e189c3c9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $97077f52e189c3c9$var$_baseNew = $97077f52e189c3c9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $97077f52e189c3c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Stopwatch".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97077f52e189c3c9$var$StopwatchIcon = (props)=>/*#__PURE__*/ $97077f52e189c3c9$var$_react.default.createElement($97077f52e189c3c9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 3.75v-3m0 3a5.73 5.73 0 0 1 3.885 1.511M8 3.75a5.73 5.73 0 0 0-3.885 1.511M8 .75h3m-3 0H5m8.5 2.75-1.615 1.761M2.5 3.5l1.615 1.761m7.77 0a5.75 5.75 0 1 1-7.77 0M7.75 9.75 10.292 7"/>`
    }, props));
$97077f52e189c3c9$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $97077f52e189c3c9$var$_default = module.exports.default = $97077f52e189c3c9$var$StopwatchIcon;

});

parcelRegister("63gsv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $467fca4622452061$var$_react = $467fca4622452061$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $467fca4622452061$var$_stopwatch = $467fca4622452061$var$_interopRequireDefault((parcelRequire("cXVn2")));
function $467fca4622452061$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $467fca4622452061$var$StopwatchIcon = (props)=>/*#__PURE__*/ $467fca4622452061$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.587 6.988.626-.664c.203-.215.481-.324.76-.324.247 0 .496.086.694.262a.98.98 0 0 1 .063 1.414l-.565.6a7 7 0 1 1-10.33 0l-.564-.6a.98.98 0 0 1 .062-1.414A1.04 1.04 0 0 1 7.03 6c.278 0 .556.109.76.324l.624.664a7 7 0 0 1 2.582-.916L10.998 5H10.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.498l.001 1.071a7 7 0 0 1 2.584.917M12 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10m.368-4.232a.796.796 0 0 1-1.14-.018.834.834 0 0 1 .018-1.163l2.386-2.355a.796.796 0 0 1 1.14.018.834.834 0 0 1-.018 1.163z"/></svg>`
    }, props, {
        newIcon: $467fca4622452061$var$_stopwatch.default
    }));
$467fca4622452061$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $467fca4622452061$var$_default = module.exports.default = $467fca4622452061$var$StopwatchIcon;

});


parcelRegister("hOz5f", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97410304d65c75a49262fb87a970fbff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf825211d8a9eeef$var$_react = $cf825211d8a9eeef$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cf825211d8a9eeef$var$_baseNew = $cf825211d8a9eeef$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $cf825211d8a9eeef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "OnCall".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing on-call across Atlassian products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf825211d8a9eeef$var$OnCallIcon = (props)=>/*#__PURE__*/ $cf825211d8a9eeef$var$_react.default.createElement($cf825211d8a9eeef$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2.319 8.693 2.43-2.026a1 1 0 0 0 .322-1.043L4.25 2.75H.75c0 2.13.573 4.16 1.569 5.943Zm0 0a13 13 0 0 0 4.988 4.988m0 0a12.17 12.17 0 0 0 5.943 1.569v-3.5l-2.874-.821a1 1 0 0 0-1.043.321z"/><path fill="currentcolor" d="M16 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-2.5 2.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M11 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$cf825211d8a9eeef$var$OnCallIcon.displayName = 'OnCallIcon';
var $cf825211d8a9eeef$var$_default = module.exports.default = $cf825211d8a9eeef$var$OnCallIcon;

});

parcelRegister("6mI6x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8914d2a187838765$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $8914d2a187838765$var$AlertIconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.75 16.9997C18.879 16.9997 18.962 16.9587 19 16.9297V16.3027C17.654 15.8967 16.659 14.7767 16.483 13.4267L16.479 13.3977L16.477 13.3677L16.036 9.00169C15.797 7.28869 14.067 5.99969 12 5.99969C9.933 5.99969 8.203 7.28869 7.964 9.00169L7.523 13.3677L7.521 13.3977L7.517 13.4267C7.341 14.7767 6.347 15.8967 5 16.3027V16.9297C5.038 16.9587 5.121 16.9997 5.25 16.9997H18.75ZM18.467 13.1677C18.547 13.7817 19.051 14.2847 19.728 14.4267C20.473 14.5817 21 15.1737 21 15.8537V17.0007C21 18.1047 19.993 18.9997 18.75 18.9997H5.25C4.007 18.9997 3 18.1047 3 17.0007V15.8537C3 15.1737 3.527 14.5817 4.272 14.4267C4.949 14.2847 5.453 13.7817 5.533 13.1677L5.978 8.76769C6.293 6.3517 8.378 4.47169 11 4.08269V2.99969C11 2.44769 11.447 1.99969 12 1.99969C12.553 1.99969 13 2.44769 13 2.99969V4.08269C15.622 4.47169 17.707 6.3517 18.022 8.76769L18.467 13.1677ZM14 20C14 21.104 13.104 22 12 22C10.896 22 10 21.104 10 20H14Z",
        fill: "currentColor"
    }));
/**
 * __AlertIcon__
 */ const $8914d2a187838765$var$AlertIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $8914d2a187838765$var$AlertIconGlyph
    });
var $8914d2a187838765$export$2e2bcd8739ae039 = $8914d2a187838765$var$AlertIcon;

});

parcelRegister("4WNKY", function(module, exports) {

$parcel$export(module.exports, "default", () => $573a8d0da00bdfd2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $573a8d0da00bdfd2$var$AutomationsIconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.05237 4.25623C9.3413 3.64085 9.96048 3.2485 10.6403 3.25L17.0039 3.26406C17.6828 3.26556 18.2997 3.65966 18.5863 4.27513C18.873 4.8906 18.7779 5.61635 18.3421 6.13708L16.6204 8.19482H16.8597C17.5765 8.19482 18.2208 8.63193 18.4858 9.29795C18.7507 9.96397 18.5828 10.7242 18.0618 11.2166L8.48184 20.2718C7.85583 20.8635 6.89231 20.9117 6.21042 20.3853C5.52853 19.859 5.33108 18.9147 5.74495 18.1592L7.75245 14.4948H7C6.40117 14.4948 5.84391 14.1886 5.52283 13.6831C5.20174 13.1777 5.16141 12.5431 5.41593 12.001L9.05237 4.25623ZM10.7066 12.7448L7.27973 19L16.8597 9.94482H12.8742L17 5.01406L10.6364 5L7 12.7448H10.7066Z"
    }));
/**
 * __AutomationsIcon__
 */ const $573a8d0da00bdfd2$var$AutomationsIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $573a8d0da00bdfd2$var$AutomationsIconGlyph
    });
var $573a8d0da00bdfd2$export$2e2bcd8739ae039 = $573a8d0da00bdfd2$var$AutomationsIcon;

});

parcelRegister("2qHz8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d65c86c8ad65602$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $7d65c86c8ad65602$var$HeartbeatsIconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0001 9.43995L13.7601 7.69595C14.2289 7.23305 14.8613 6.97348 15.5201 6.97348C16.179 6.97348 16.8113 7.23305 17.2801 7.69595C17.511 7.92394 17.6943 8.19549 17.8194 8.49487C17.9445 8.79425 18.0089 9.11548 18.0089 9.43995C18.0089 9.76442 17.9445 10.0857 17.8194 10.385C17.6943 10.6844 17.511 10.956 17.2801 11.184L12.0001 16.417L6.72012 11.185C6.48894 10.9569 6.30537 10.6853 6.18008 10.3857C6.05479 10.0861 5.99027 9.76466 5.99027 9.43995C5.99027 9.11524 6.05479 8.79377 6.18008 8.49421C6.30537 8.19465 6.48894 7.92297 6.72012 7.69495C7.18895 7.23205 7.82127 6.97249 8.48011 6.97249C9.13896 6.97249 9.77129 7.23205 10.2401 7.69495V7.69595L12.0001 9.43995ZM5.31612 12.583L5.31912 12.587L11.6411 18.853C11.7364 18.9481 11.8655 19.0015 12.0001 19.0015C12.1347 19.0015 12.2639 18.9481 12.3591 18.853L18.6811 12.587L18.6841 12.583L18.6881 12.58C19.1039 12.1695 19.434 11.6806 19.6594 11.1416C19.8847 10.6026 20.0007 10.0242 20.0007 9.43995C20.0007 8.85573 19.8847 8.27732 19.6594 7.73829C19.434 7.19927 19.1039 6.71036 18.6881 6.29995C17.8442 5.46673 16.706 4.99951 15.5201 4.99951C14.3342 4.99951 13.196 5.46673 12.3521 6.29995L12.3491 6.30395L12.3451 6.30695L12.0001 6.64995L11.6551 6.30795L11.6511 6.30495L11.6481 6.30195C10.8042 5.46873 9.66604 5.00151 8.48011 5.00151C7.29419 5.00151 6.15601 5.46873 5.31212 6.30195C4.89648 6.71235 4.56646 7.20119 4.34122 7.74012C4.11598 8.27905 4 8.85735 4 9.44145C4 10.0256 4.11598 10.6039 4.34122 11.1428C4.56646 11.6817 4.89648 12.1706 5.31212 12.581L5.31612 12.584V12.583Z"
    }));
/**
 * __HeartbeatsIcon__
 */ const $7d65c86c8ad65602$var$HeartbeatsIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $7d65c86c8ad65602$var$HeartbeatsIconGlyph
    });
var $7d65c86c8ad65602$export$2e2bcd8739ae039 = $7d65c86c8ad65602$var$HeartbeatsIcon;

});

parcelRegister("707IR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6cda68e1f914200$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $e6cda68e1f914200$var$OnCallIconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentColor",
        d: "M9.09201 2C10.409 2 11.445 3.111 11.336 4.408L11.1 7.227C11.0509 7.7725 10.7988 8.27969 10.3936 8.6482C9.98846 9.01672 9.4597 9.21971 8.91201 9.217H8.88601C8.77201 10.079 8.71501 10.947 8.71501 11.807V11.979C8.71501 12.9 8.78101 13.84 8.91201 14.784C10.054 14.784 11.005 15.65 11.1 16.774L11.337 19.592C11.446 20.89 10.41 22 9.09201 22H7.46201C6.08701 22 4.83801 21.092 4.35301 19.741C3.4553 17.2521 2.99747 14.6259 3.00001 11.98V11.809C3.00001 9.199 3.45301 6.648 4.34901 4.228C4.84901 2.874 6.06401 2 7.44601 2H9.09201ZM9.09301 4.222H7.44601C7.02101 4.222 6.63501 4.523 6.46301 4.989C5.65643 7.17179 5.24567 9.48096 5.25001 11.808V11.978C5.25001 14.376 5.65501 16.722 6.45601 18.951C6.64401 19.472 7.03201 19.778 7.46301 19.778H9.09301L8.86001 17.007H7.00701L6.84201 16.092C6.59335 14.7351 6.46685 13.3585 6.46401 11.979V11.808C6.46401 10.511 6.58101 9.2 6.81401 7.911L6.97801 6.994H8.86001L9.09301 4.222ZM18.546 10.333C19.477 10.333 20.233 11.08 20.233 12C20.233 12.921 19.477 13.667 18.546 13.667C18.3257 13.6684 18.1073 13.6265 17.9032 13.5435C17.6991 13.4605 17.5134 13.3381 17.3566 13.1833C17.1998 13.0284 17.0751 12.8443 16.9896 12.6412C16.904 12.4382 16.8593 12.2203 16.858 12C16.858 11.08 17.614 10.333 18.546 10.333ZM14.046 10.333C14.977 10.333 15.733 11.08 15.733 12C15.733 12.921 14.977 13.667 14.046 13.667C13.8257 13.6684 13.6073 13.6265 13.4032 13.5435C13.1991 13.4605 13.0134 13.3381 12.8566 13.1833C12.6998 13.0284 12.5751 12.8443 12.4896 12.6412C12.404 12.4382 12.3593 12.2203 12.358 12C12.358 11.08 13.114 10.333 14.046 10.333Z"
    }));
/**
 * __OnCallIcon__
 */ const $e6cda68e1f914200$var$OnCallIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $e6cda68e1f914200$var$OnCallIconGlyph
    });
var $e6cda68e1f914200$export$2e2bcd8739ae039 = $e6cda68e1f914200$var$OnCallIcon;

});

parcelRegister("b2Hwm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d75c1c4c2cdf8cd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $1d75c1c4c2cdf8cd$var$PoliciesIconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 14H19V9H5V14H7V13C7 12.7348 7.10536 12.4804 7.29289 12.2929C7.48043 12.1054 7.73478 12 8 12C8.26522 12 8.51957 12.1054 8.70711 12.2929C8.89464 12.4804 9 12.7348 9 13V14H15V13C15 12.7348 15.1054 12.4804 15.2929 12.2929C15.4804 12.1054 15.7348 12 16 12C16.2652 12 16.5196 12.1054 16.7071 12.2929C16.8946 12.4804 17 12.7348 17 13V14ZM17 16V17C17 17.2652 16.8946 17.5196 16.7071 17.7071C16.5196 17.8946 16.2652 18 16 18C15.7348 18 15.4804 17.8946 15.2929 17.7071C15.1054 17.5196 15 17.2652 15 17V16H9V17C9 17.2652 8.89464 17.5196 8.70711 17.7071C8.51957 17.8946 8.26522 18 8 18C7.73478 18 7.48043 17.8946 7.29289 17.7071C7.10536 17.5196 7 17.2652 7 17V16H5V19H19V16H17ZM9 7H15V6H9V7ZM7 7V5C7 4.73478 7.10536 4.48043 7.29289 4.29289C7.48043 4.10536 7.73478 4 8 4H16C16.2652 4 16.5196 4.10536 16.7071 4.29289C16.8946 4.48043 17 4.73478 17 5V7H19C19.5304 7 20.0391 7.21071 20.4142 7.58579C20.7893 7.96086 21 8.46957 21 9V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V9C3 8.46957 3.21071 7.96086 3.58579 7.58579C3.96086 7.21071 4.46957 7 5 7H7Z"
    }));
/**
 * __PoliciesIcon__
 */ const $1d75c1c4c2cdf8cd$var$PoliciesIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $1d75c1c4c2cdf8cd$var$PoliciesIconGlyph
    });
var $1d75c1c4c2cdf8cd$export$2e2bcd8739ae039 = $1d75c1c4c2cdf8cd$var$PoliciesIcon;

});

parcelRegister("jASxh", function(module, exports) {

$parcel$export(module.exports, "default", () => $43d894138745be37$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/consistent-props-definitions */ 
var $5uXOq = parcelRequire("5uXOq");


var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");


var $jsTfk = parcelRequire("jsTfk");

var $juVrZ = parcelRequire("juVrZ");

var $jSfqD = parcelRequire("jSfqD");

var $6cAn5 = parcelRequire("6cAn5");
const $43d894138745be37$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    width: '1.5rem',
    height: '1.5rem'
});
/**
 * __Footer__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $43d894138745be37$var$OldFooter = (props)=>{
    const cssFn = (0, $jsTfk.overrideStyleFunction)(()=>({
            userSelect: 'auto',
            display: 'block',
            textAlign: 'center',
            minHeight: '24px',
            alignItems: 'center',
            width: '100%',
            '[data-item-elem-before]': {
                marginRight: "var(--ds-space-0, 0px)",
                marginBottom: "var(--ds-space-100, 8px)",
                display: 'inline-block'
            },
            '[data-item-title]': {
                textAlign: 'center',
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
            },
            '[data-item-description]': {
                textAlign: 'center',
                display: 'inline-block',
                margin: "var(--ds-space-075, 6px)"
            },
            // Will look interactive if the `component` is anything other than a div.
            'div&:hover': {
                backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
                cursor: 'default'
            },
            'div&:active': {
                backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
                color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
            }
        }), props.cssFn);
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ iconBefore: iconBefore, onClick: onClick, description: description, children: children, testId: testId })=>({
            iconBefore: iconBefore,
            onClick: onClick,
            description: description,
            children: children,
            testId: testId
        }))(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSfqD.default), {
        ...safeProps,
        component: props.component || (0, $juVrZ.Container),
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: cssFn
    });
};
/**
 * __Footer__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $43d894138745be37$var$Footer = ({ description: description, children: children, iconBefore: iconBefore, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.100",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $43d894138745be37$var$iconContainerStyles
    }, iconBefore), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "UNSAFE_small",
        align: "center",
        color: "inherit"
    }, children), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "UNSAFE_small",
        as: "p",
        align: "center",
        color: "color.text.subtlest"
    }, description))));
};
/**
 * __Footer__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $43d894138745be37$var$FooterFacade = ({ useDeprecatedApi: useDeprecatedApi = true, description: description, iconBefore: iconBefore, testId: testId, children: children, component: component, cssFn: cssFn, onClick: onClick })=>{
    if (!useDeprecatedApi) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($43d894138745be37$var$Footer, {
        iconBefore: iconBefore,
        description: description,
        testId: testId
    }, children);
    typeof $6cAn5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($43d894138745be37$var$OldFooter, {
        onClick: onClick,
        component: component,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: cssFn,
        iconBefore: iconBefore,
        description: description,
        testId: testId
    }, children);
};
var $43d894138745be37$export$2e2bcd8739ae039 = $43d894138745be37$var$FooterFacade;

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("2hFr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf6493a1aea2c0eb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $35XSW = parcelRequire("35XSW");
var $4uxPN = parcelRequire("4uxPN");
var $lObw7 = parcelRequire("lObw7");

var $j9VTE = parcelRequire("j9VTE");
function $cf6493a1aea2c0eb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cf6493a1aea2c0eb$var$baseMotionStyles = {
    name: "ro982m",
    styles: "position:absolute;z-index:1;top:0;right:0;left:0"
};
const $cf6493a1aea2c0eb$var$enteringStyles = {
    name: "3g1s6n",
    styles: "position:static;z-index:2"
};
/**
 * __Loading items__
 *
 * Loading items conditionally render based on the useShouldNestedElementRender() hook.
 */ const $cf6493a1aea2c0eb$var$LoadingItems = ({ children: children, isLoading: isLoading, fallback: fallback, testId: testId })=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return children;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $35XSW.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4uxPN.default), {
        key: `loading-section-${isLoading}`,
        duration: (0, $lObw7.mediumDurationMs)
    }, (motion, state)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            ...motion,
            "data-testid": testId && `${testId}--${state}`,
            css: [
                $cf6493a1aea2c0eb$var$baseMotionStyles,
                state === 'entering' && $cf6493a1aea2c0eb$var$enteringStyles
            ]
        }, isLoading ? fallback : children)));
};
var $cf6493a1aea2c0eb$export$2e2bcd8739ae039 = $cf6493a1aea2c0eb$var$LoadingItems;

});

parcelRegister("4PB4I", function(module, exports) {

$parcel$export(module.exports, "default", () => $1889ca1dd837c218$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $1889ca1dd837c218$var$navigationFooterStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});
/**
 * __Navigation footer__
 *
 * Allows for customisation of the footer.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $1889ca1dd837c218$var$NavigationFooter = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.100",
        paddingBlockEnd: "space.200",
        xcss: $1889ca1dd837c218$var$navigationFooterStyles
    }, children);
};
var $1889ca1dd837c218$export$2e2bcd8739ae039 = $1889ca1dd837c218$var$NavigationFooter;

});

parcelRegister("jSRx6", function(module, exports) {

$parcel$export(module.exports, "SavedSearches", () => $56dc0139961aa1b7$export$b86ffbe28c8f5004);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $42CjB = parcelRequire("42CjB");

var $5Fuj0 = parcelRequire("5Fuj0");

var $5IcUR = parcelRequire("5IcUR");

var $7piTm = parcelRequire("7piTm");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $fNobW = parcelRequire("fNobW");

var $gjTBi = parcelRequire("gjTBi");

var $3bDjY = parcelRequire("3bDjY");

var $1a6oa = parcelRequire("1a6oa");

var $dY87H = parcelRequire("dY87H");

var $kHsrA = parcelRequire("kHsrA");

var $d2Lea = parcelRequire("d2Lea");

var $9ftda = parcelRequire("9ftda");

var $cp8tc = parcelRequire("cp8tc");

var $3IyOX = parcelRequire("3IyOX");
const $56dc0139961aa1b7$export$b86ffbe28c8f5004 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isOpenCreatedByMe: isOpenCreatedByMe, isOpenSharedWithMe: isOpenSharedWithMe, setIsOpenCreatedByMe: setIsOpenCreatedByMe, setIsOpenSharedWithMe: setIsOpenSharedWithMe, selectedItemId: selectedItemId, handleItemClick: handleItemClick, isPageLoading: isPageLoading, starredItem: starredItem, expandSharedWithMe: expandSharedWithMe, expandCreatedByMe: expandCreatedByMe, isSharedWithMeExpanded: isSharedWithMeExpanded, isCreatedByMeExpanded: isCreatedByMeExpanded, createdByMeSearches: createdByMeSearches, sharedWithMeSearches: sharedWithMeSearches, notVisibleCreatedByMeCount: notVisibleCreatedByMeCount, notVisibleSharedWithMeCount: notVisibleSharedWithMeCount, defaultFilters: defaultFilters, handleStar: handleStar, openDeleteModal: openDeleteModal, closeDeleteModal: closeDeleteModal, isDeleteLoading: isDeleteLoading, handleDeleteModalSubmit: handleDeleteModalSubmit, isDeleteModalOpen: isDeleteModalOpen } = (0, $d2Lea.useSavedSearchController)();
    const SpotlightWrapper = isPageLoading ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment : (0, $5Fk4Z.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "eoc-alert-list-saved-searches-loading",
        hold: isPageLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $cp8tc.default).starred)
    }, isPageLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ftda.LoadingRow), null), !isPageLoading && !starredItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            margin: `${"var(--ds-space-100, 8px)"} 10px`
        }
    }, formatMessage((0, $cp8tc.default).starredEmpty)), !isPageLoading && starredItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IyOX.StyledButtonItem), {
        onClick: ()=>handleItemClick(starredItem, 'starred-item'),
        isSelected: starredItem.id === selectedItemId,
        iconAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            className: "action-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $cp8tc.default).unstarTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            label: formatMessage((0, $cp8tc.default).starIconLabel),
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5IcUR))), {
                    ...iconProps,
                    color: "var(--ds-icon-warning, #ffc400)",
                    LEGACY_size: "small"
                }),
            onClick: (event)=>{
                event.stopPropagation();
                handleStar('');
            },
            appearance: "subtle",
            spacing: "compact"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $cp8tc.default).deleteTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            label: formatMessage((0, $cp8tc.default).deleteIconLabel),
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5Fuj0))), {
                    ...iconProps,
                    LEGACY_size: "small"
                }),
            onClick: (event)=>{
                event.stopPropagation();
                openDeleteModal(starredItem.id);
            },
            appearance: "subtle",
            spacing: "compact"
        })))
    }, starredItem.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SpotlightWrapper, {
        name: (0, $kHsrA.SPOTLIGHT_NAMES).sidebarItems
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $cp8tc.default).filters)
    }, isPageLoading ? Array.from({
        length: 6
    }).map((_, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ftda.LoadingRow), {
            key: idx
        })) : Object.entries(defaultFilters).map((defaultFilter)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IyOX.StyledButtonItem), {
            key: defaultFilter[1].name,
            onClick: ()=>handleItemClick(defaultFilter[1], 'default-filters'),
            isSelected: defaultFilter[1].id === selectedItemId
        }, formatMessage((0, $cp8tc.default)[defaultFilter[0]]))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IyOX.StyledExpandableSection), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IyOX.StyledExpandableSectionTitle), null, formatMessage((0, $cp8tc.default).sharedWithMe)),
        isOpen: isOpenSharedWithMe,
        onClick: ()=>setIsOpenSharedWithMe(!isOpenSharedWithMe)
    }, isPageLoading && Array.from({
        length: 2
    }).map((_, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ftda.LoadingRow), {
            key: idx
        })), !isPageLoading && !sharedWithMeSearches?.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            margin: `${"var(--ds-space-100, 8px)"} 10px`
        }
    }, formatMessage((0, $cp8tc.default).sharedWithMeEmpty)), !isPageLoading && sharedWithMeSearches?.map((sharedSearch)=>{
        return sharedSearch.id !== starredItem?.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IyOX.StyledButtonItem), {
            key: sharedSearch.id,
            onClick: ()=>{
                handleItemClick(sharedSearch, 'shared-with-me');
            },
            isSelected: sharedSearch.id === selectedItemId,
            iconAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
                className: "action-wrapper"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $cp8tc.default).starTooltip)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                label: formatMessage((0, $cp8tc.default).starIconLabel),
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7piTm))), {
                        ...iconProps,
                        LEGACY_size: "small"
                    }),
                onClick: (event)=>{
                    event.stopPropagation();
                    handleStar(sharedSearch.id);
                },
                appearance: "subtle",
                spacing: "compact"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $cp8tc.default).deleteTooltip)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                label: formatMessage((0, $cp8tc.default).deleteIconLabel),
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5Fuj0))), {
                        ...iconProps,
                        LEGACY_size: "small"
                    }),
                onClick: (event)=>{
                    event.stopPropagation();
                    openDeleteModal(sharedSearch.id);
                },
                appearance: "subtle",
                spacing: "compact"
            })))
        }, sharedSearch.name) : null;
    }), !isPageLoading && !isSharedWithMeExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IyOX.StyledMoreText), {
        onClick: expandSharedWithMe
    }, formatMessage((0, $cp8tc.default).moreText, {
        count: notVisibleSharedWithMeCount
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IyOX.StyledExpandableSection), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IyOX.StyledExpandableSectionTitle), null, formatMessage((0, $cp8tc.default).createdByMe)),
        isOpen: isOpenCreatedByMe,
        onClick: ()=>setIsOpenCreatedByMe(!isOpenCreatedByMe)
    }, isPageLoading && Array.from({
        length: 2
    }).map((_, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ftda.LoadingRow), {
            key: idx
        })), !isPageLoading && !createdByMeSearches?.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            margin: `${"var(--ds-space-100, 8px)"} 10px`
        }
    }, formatMessage((0, $cp8tc.default).createdByMeEmpty)), !isPageLoading && createdByMeSearches?.map((createdSearch)=>{
        return createdSearch.id !== starredItem?.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IyOX.StyledButtonItem), {
            key: createdSearch.id,
            onClick: ()=>handleItemClick(createdSearch, 'created-by-me'),
            isSelected: createdSearch.id === selectedItemId,
            iconAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
                className: "action-wrapper"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $cp8tc.default).starTooltip)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                label: formatMessage((0, $cp8tc.default).starIconLabel),
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7piTm))), {
                        ...iconProps,
                        LEGACY_size: "small"
                    }),
                onClick: (event)=>{
                    event.stopPropagation();
                    handleStar(createdSearch.id);
                },
                appearance: "subtle",
                spacing: "compact"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $cp8tc.default).deleteTooltip)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                label: formatMessage((0, $cp8tc.default).deleteIconLabel),
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5Fuj0))), {
                        ...iconProps,
                        LEGACY_size: "small"
                    }),
                onClick: (event)=>{
                    event.stopPropagation();
                    openDeleteModal(createdSearch.id);
                },
                appearance: "subtle",
                spacing: "compact"
            })))
        }, createdSearch.name) : null;
    }), !isPageLoading && !isCreatedByMeExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IyOX.StyledMoreText), {
        onClick: expandCreatedByMe
    }, formatMessage((0, $cp8tc.default).moreText, {
        count: notVisibleCreatedByMeCount
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1a6oa.DeleteModal), {
        messageDescriptors: {
            title: (0, $cp8tc.default).deleteModalTitle,
            description: (0, $cp8tc.default).deleteModalDescription
        },
        isDeleteDialogOpen: isDeleteModalOpen,
        onDeleteAttemptCancel: closeDeleteModal,
        isLoading: isDeleteLoading,
        onDelete: handleDeleteModalSubmit
    }));
};

});
parcelRegister("5Fuj0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cdbc673522c6bc8690e33483f21d93d5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42084a291eb7f82a$var$_react = $42084a291eb7f82a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42084a291eb7f82a$var$_delete = $42084a291eb7f82a$var$_interopRequireDefault((parcelRequire("4IrpZ")));

var $42084a291eb7f82a$var$_remove = $42084a291eb7f82a$var$_interopRequireDefault((parcelRequire("f5BqX")));
function $42084a291eb7f82a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for DeleteIcon.
 * This component is DeleteIcon, with `UNSAFE_fallbackIcon` set to "EditorRemoveIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42084a291eb7f82a$var$DeleteIcon = (props)=>/*#__PURE__*/ $42084a291eb7f82a$var$_react.default.createElement($42084a291eb7f82a$var$_delete.default, Object.assign({
        LEGACY_fallbackIcon: $42084a291eb7f82a$var$_remove.default
    }, props));
$42084a291eb7f82a$var$DeleteIcon.Name = 'DeleteIconMigration';
var $42084a291eb7f82a$var$_default = module.exports.default = $42084a291eb7f82a$var$DeleteIcon;

});
parcelRegister("4IrpZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c4d83f5979cfae4264098ab1c131716f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36f08a2f957bd6ab$var$_react = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $36f08a2f957bd6ab$var$_baseNew = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $36f08a2f957bd6ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36f08a2f957bd6ab$var$DeleteIcon = (props)=>/*#__PURE__*/ $36f08a2f957bd6ab$var$_react.default.createElement($36f08a2f957bd6ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.75 3.25V14c0 .69-.56 1.25-1.25 1.25h-7c-.69 0-1.25-.56-1.25-1.25V3.25m9.5 0h1.75m-1.75 0h-2.5m-7 0H1.5m1.75 0h2.5m0 0V.75h4.5v2.5m-4.5 0h4.5M6.5 5.5V13m3-7.5V13"/>`
    }, props));
$36f08a2f957bd6ab$var$DeleteIcon.displayName = 'DeleteIcon';
var $36f08a2f957bd6ab$var$_default = module.exports.default = $36f08a2f957bd6ab$var$DeleteIcon;

});

parcelRegister("f5BqX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afc45c3418436f46$var$_react = $afc45c3418436f46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $afc45c3418436f46$var$_delete = $afc45c3418436f46$var$_interopRequireDefault((parcelRequire("4IrpZ")));
function $afc45c3418436f46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $afc45c3418436f46$var$EditorRemoveIcon = (props)=>/*#__PURE__*/ $afc45c3418436f46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m2.78 11a1 1 0 0 1-.97-.757L7.156 10.62A.5.5 0 0 1 7.64 10h8.72a.5.5 0 0 1 .485.621l-1.656 6.622a1 1 0 0 1-.97.757zM11 6h2a1 1 0 0 1 1 1h-4a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $afc45c3418436f46$var$_delete.default
    }));
$afc45c3418436f46$var$EditorRemoveIcon.displayName = 'EditorRemoveIcon';
var $afc45c3418436f46$var$_default = module.exports.default = $afc45c3418436f46$var$EditorRemoveIcon;

});


parcelRegister("dY87H", function(module, exports) {

$parcel$export(module.exports, "Flex", () => $2ce7fa80ca46705d$export$f51f4c4ede09e011);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");

var $bWGt6 = parcelRequire("bWGt6");
const $2ce7fa80ca46705d$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e18obzhx0"
})("display:flex;flex:", ({ flex: flex })=>flex, ";flex-basis:", ({ flexBasis: flexBasis })=>flexBasis, ";flex-direction:", ({ flexDirection: flexDirection })=>flexDirection, ";flex-flow:", ({ flexFlow: flexFlow })=>flexFlow, ";flex-grow:", ({ flexGrow: flexGrow })=>flexGrow, ";flex-shrink:", ({ flexShrink: flexShrink })=>flexShrink, ";flex-wrap:", ({ flexWrap: flexWrap })=>flexWrap, ";align-content:", ({ alignContent: alignContent })=>alignContent, ";align-items:", ({ alignItems: alignItems })=>alignItems, ";align-self:", ({ alignSelf: alignSelf })=>alignSelf, ";justify-content:", ({ justifyContent: justifyContent })=>justifyContent, ";order:", ({ order: order })=>order, ";place-items:", ({ placeItems: placeItems })=>placeItems, ";place-self:", ({ placeSelf: placeSelf })=>placeSelf, ";place-content:", ({ placeContent: placeContent })=>placeContent, ";row-gap:", ({ rowGap: rowGap })=>typeof rowGap === 'number' ? `${rowGap * (0, $k5uoT.gridSize)()}px` : rowGap, ";column-gap:", ({ columnGap: columnGap })=>typeof columnGap === 'number' ? `${columnGap * (0, $k5uoT.gridSize)()}px` : columnGap, ";");

});

parcelRegister("kHsrA", function(module, exports) {

$parcel$export(module.exports, "MORE_OPTIONS", () => $6432df1c98d97999$export$37ea988405e4e1a5);
$parcel$export(module.exports, "STATUS_OPTIONS", () => $6432df1c98d97999$export$558e8ef8f8c97d57);
$parcel$export(module.exports, "OPERATOR_OPTIONS", () => $6432df1c98d97999$export$beb21d0017a21ffe);
$parcel$export(module.exports, "EMPTY_STATE_SVG_WIDTH", () => $6432df1c98d97999$export$b585c413ab459d7a);
$parcel$export(module.exports, "ERROR_STATE_SVG_WIDTH", () => $6432df1c98d97999$export$98d54da4bfad134e);
$parcel$export(module.exports, "NO_ALERTS_STATE_SVG_WIDTH", () => $6432df1c98d97999$export$d6d19aca641efb0c);
$parcel$export(module.exports, "EMPTY_STATE_SVG_HEIGHT", () => $6432df1c98d97999$export$a651b8647588fd43);
$parcel$export(module.exports, "ERROR_STATE_SVG_HEIGHT", () => $6432df1c98d97999$export$d4ee1181ace6137e);
$parcel$export(module.exports, "NO_ALERTS_STATE_SVG_HEIGHT", () => $6432df1c98d97999$export$7b9110eabc8140ad);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $6432df1c98d97999$export$a7c923252528b255);
$parcel$export(module.exports, "AlertListHandler", () => $6432df1c98d97999$export$27f5aef031efe0df);

var $fTeJv = parcelRequire("fTeJv");

var $39KIs = parcelRequire("39KIs");
const $6432df1c98d97999$export$37ea988405e4e1a5 = [
    {
        label: 'Assignee',
        value: 'owner'
    },
    {
        label: 'Deduplication',
        value: 'count'
    },
    {
        label: 'Tiny ID',
        value: 'tinyId'
    },
    {
        label: 'Tags',
        value: 'tags'
    },
    {
        label: 'Source',
        value: 'source'
    },
    {
        label: 'Entity',
        value: 'entity'
    },
    {
        label: 'Alias',
        value: 'alias'
    }
];
const $6432df1c98d97999$export$558e8ef8f8c97d57 = {
    [(0, $39KIs.STRING_LITERAL_STATUS_OPEN)]: {
        label: 'Open',
        appearance: 'removed',
        displayValue: 'open'
    },
    [(0, $39KIs.STRING_LITERAL_STATUS_ACKED)]: {
        label: 'Acknowledged',
        appearance: 'inprogress',
        displayValue: 'acked'
    },
    [(0, $39KIs.STRING_LITERAL_STATUS_SNOOZED)]: {
        label: 'Snoozed',
        appearance: 'moved',
        displayValue: 'snoozed'
    },
    [(0, $39KIs.STRING_LITERAL_STATUS_CLOSED)]: {
        label: 'Closed',
        appearance: 'default',
        lozengeAppearance: 'default',
        displayValue: 'closed'
    }
};
const $6432df1c98d97999$export$beb21d0017a21ffe = [
    {
        label: '<=',
        value: '<='
    },
    {
        label: '<',
        value: '<'
    },
    {
        label: '=',
        value: '='
    },
    {
        label: '>=',
        value: '>='
    },
    {
        label: '>',
        value: '>'
    }
];
const $6432df1c98d97999$export$b585c413ab459d7a = 167;
const $6432df1c98d97999$export$98d54da4bfad134e = 226;
const $6432df1c98d97999$export$d6d19aca641efb0c = 160;
const $6432df1c98d97999$export$a651b8647588fd43 = 146;
const $6432df1c98d97999$export$d4ee1181ace6137e = 210;
const $6432df1c98d97999$export$7b9110eabc8140ad = 136;
const $6432df1c98d97999$export$a7c923252528b255 = {
    filters: 'eoc-alert-list_filters',
    myAlerts: 'eoc-alert-list_my-alerts',
    actions: 'eoc-alert-list_actions',
    sidebarItems: 'eoc-alert-list_sidebar_items',
    headerActions: 'eoc-alert-list_header-actions',
    aiBanner: 'eoc-alert-list_ai-banner',
    aiView: 'eoc-alert-list_ai-view',
    aiGroupCountBadge: 'eoc-alert-list_ai-group-count-badge',
    responders: 'eoc-alert-list_responders'
};
class $6432df1c98d97999$export$27f5aef031efe0df extends (0, $fTeJv.AlertDetailHandler) {
    handler(message) {
        throw new Error('Not implemented');
    }
}

});
parcelRegister("fTeJv", function(module, exports) {

$parcel$export(module.exports, "AlertDetailHandler", () => $ab2842267bc48a2e$export$d349a0527395efbd);
class $ab2842267bc48a2e$export$d349a0527395efbd {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}

});


parcelRegister("d2Lea", function(module, exports) {

$parcel$export(module.exports, "useSavedSearchController", () => $5e55a1627417afff$export$6cd2bfb911e4f96a);

var $5uXOq = parcelRequire("5uXOq");

var $bmKPg = parcelRequire("bmKPg");
var $ieDtd = parcelRequire("ieDtd");
var $2YP9W = parcelRequire("2YP9W");
var $lVJAU = parcelRequire("lVJAU");

var $7Jxgt = parcelRequire("7Jxgt");

var $2NMNM = parcelRequire("2NMNM");

var $h8yj2 = parcelRequire("h8yj2");

var $93D2l = parcelRequire("93D2l");

var $gIuON = parcelRequire("gIuON");

var $39KIs = parcelRequire("39KIs");

var $jxRF2 = parcelRequire("jxRF2");

var $1Z10l = parcelRequire("1Z10l");

var $aF3ss = parcelRequire("aF3ss");

var $oacWJ = parcelRequire("oacWJ");

var $7oBCJ = parcelRequire("7oBCJ");

var $aQd57 = parcelRequire("aQd57");
const $5e55a1627417afff$var$DEFAULT_LIMIT = 3;
const $5e55a1627417afff$export$6cd2bfb911e4f96a = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [searchedQuery] = (0, $ieDtd.useQueryParam)((0, $5de925396bc7bec4$export$19f7845e9b507cf2));
    const [view] = (0, $ieDtd.useQueryParam)((0, $5de925396bc7bec4$export$8540b2e79718c77f));
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const [alertId] = (0, $bmKPg.usePathParam)('id');
    const { data: user } = (0, $2YP9W.useResource)((0, $jxRF2.eocUserResource));
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { removeSavedSearchFromCreatedByMe: removeSavedSearchFromCreatedByMe } = (0, $aQd57.useSavedSearchRelayUtils)();
    const defaultFilters = (0, $5uXOq.useMemo)(()=>{
        return {
            allSearch: {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))(),
                name: 'All',
                query: (0, $1Z10l.getDefaultFilterQuery)('', teamId)
            },
            openSearch: {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))(),
                name: 'Open',
                query: (0, $1Z10l.getDefaultFilterQuery)(`${(0, $39KIs.IDENTIFIER_STATUS)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.STRING_LITERAL_STATUS_OPEN)}`, teamId)
            },
            closedSearch: {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))(),
                name: 'Closed',
                query: (0, $1Z10l.getDefaultFilterQuery)(`${(0, $39KIs.IDENTIFIER_STATUS)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.STRING_LITERAL_STATUS_CLOSED)}`, teamId)
            },
            unackedSearch: {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))(),
                name: 'Unacknowledged',
                query: (0, $1Z10l.getDefaultFilterQuery)(`${(0, $39KIs.IDENTIFIER_STATUS)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.STRING_LITERAL_STATUS_OPEN)} ${(0, $39KIs.LOGICAL_OPERATOR_AND)} ${(0, $39KIs.IDENTIFIER_ACKNOWLEDGED)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.BOOLEAN_LITERAL_FALSE)}`, teamId)
            },
            notSeenSearch: {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))(),
                name: 'Not seen',
                query: (0, $1Z10l.getDefaultFilterQuery)(`${(0, $39KIs.IDENTIFIER_IS_SEEN)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $39KIs.BOOLEAN_LITERAL_FALSE)}`, teamId)
            },
            assignedToMeSearch: {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))(),
                name: 'Assigned to me',
                query: (0, $1Z10l.getDefaultFilterQuery)(`${(0, $39KIs.IDENTIFIER_ASSIGNEE)}${(0, $39KIs.OPERATOR_EQUAL_TO)} ${(0, $1Z10l.withQuote)(user?.accountId || 'me')}`, teamId)
            }
        };
    }, [
        teamId,
        user
    ]);
    const { data: savedSearches, loading: isSavedSearchesLoading } = (0, $2YP9W.useResource)((0, $oacWJ.savedSearchesResource));
    const { data: uiPreferences, isLoading: isUiPreferencesLoading, update: update } = (0, $7oBCJ.useUiPreferencesService)();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $5uXOq.useState)(false);
    const [idToDelete, setIdToDelete] = (0, $5uXOq.useState)('');
    const openDeleteModal = (id)=>{
        setIsDeleteModalOpen(true);
        setIdToDelete(id);
    };
    const closeDeleteModal = ()=>{
        setIsDeleteModalOpen(false);
        setIdToDelete('');
    };
    const { isDeleteLoading: isDeleteLoading, deleteSavedSearch: deleteSavedSearch } = (0, $aF3ss.useSavedSearchService)();
    const handleDeleteModalSubmit = ()=>{
        deleteSavedSearch(idToDelete).then(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'savedSearch deleted');
            removeSavedSearchFromCreatedByMe(idToDelete);
        }).catch(()=>{}).finally(()=>{
            closeDeleteModal();
        });
    };
    const isPageLoading = isSavedSearchesLoading || isUiPreferencesLoading || (0, $gIuON.isServer)();
    const [isOpenSharedWithMe, setIsOpenSharedWithMe] = (0, $5uXOq.useState)(true);
    const [isOpenCreatedByMe, setIsOpenCreatedByMe] = (0, $5uXOq.useState)(true);
    const [isSharedWithMeExpanded, setIsSharedWithMeExpanded] = (0, $5uXOq.useState)(false);
    const [isCreatedByMeExpanded, setIsCreatedByMeExpanded] = (0, $5uXOq.useState)(false);
    const [selectedItemId, setSelectedItemId] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        if (!searchedQuery) {
            setSelectedItemId(defaultFilters.allSearch.id);
            return;
        }
        const allSavedSearches = [
            ...Object.values(defaultFilters),
            ...savedSearches?.createdByMe ?? [],
            ...savedSearches?.sharedWithMe ?? []
        ];
        const foundSavedSearch = allSavedSearches.find((savedSearch)=>savedSearch.query === searchedQuery);
        setSelectedItemId(foundSavedSearch?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const createdByMeSearches = (0, $5uXOq.useMemo)(()=>{
        return savedSearches?.createdByMe.slice(0, isCreatedByMeExpanded ? savedSearches.createdByMe.length : $5e55a1627417afff$var$DEFAULT_LIMIT);
    }, [
        isCreatedByMeExpanded,
        savedSearches?.createdByMe
    ]);
    const notVisibleCreatedByMeCount = (0, $5uXOq.useMemo)(()=>{
        if (!savedSearches || !createdByMeSearches) return;
        return savedSearches.createdByMe.length - createdByMeSearches.length;
    }, [
        createdByMeSearches,
        savedSearches
    ]);
    const sharedWithMeSearches = (0, $5uXOq.useMemo)(()=>{
        return savedSearches?.sharedWithMe.slice(0, isSharedWithMeExpanded ? savedSearches.sharedWithMe.length : $5e55a1627417afff$var$DEFAULT_LIMIT);
    }, [
        isSharedWithMeExpanded,
        savedSearches?.sharedWithMe
    ]);
    const notVisibleSharedWithMeCount = (0, $5uXOq.useMemo)(()=>{
        if (!savedSearches || !sharedWithMeSearches) return;
        return savedSearches.sharedWithMe.length - sharedWithMeSearches.length;
    }, [
        savedSearches,
        sharedWithMeSearches
    ]);
    const starredItem = (0, $5uXOq.useMemo)(()=>{
        if (!uiPreferences || !savedSearches) return;
        const { createdByMe: createdByMe = [], sharedWithMe: sharedWithMe = [] } = savedSearches;
        return [
            ...createdByMe,
            ...sharedWithMe
        ].find((savedSearch)=>savedSearch.id === uiPreferences.defaultSavedSearchId);
    }, [
        savedSearches,
        uiPreferences
    ]);
    const handleItemClick = (0, $5uXOq.useCallback)((item, type)=>{
        const url = view === 'detail' ? (0, $93D2l.getDetailUrl)(alertId, teamId, item.query) : (0, $93D2l.getListUrl)(teamId, item.query);
        push(url);
        setSelectedItemId(item.id);
        const event = createAnalyticsEvent({});
        (0, $h8yj2.fireUIAnalytics)(event, 'savedSearch clicked');
    }, [
        alertId,
        createAnalyticsEvent,
        push,
        teamId,
        view
    ]);
    const expandSharedWithMe = ()=>{
        setIsSharedWithMeExpanded(true);
    };
    const expandCreatedByMe = ()=>{
        setIsCreatedByMeExpanded(true);
    };
    (0, $5uXOq.useEffect)(()=>{
        if (notVisibleCreatedByMeCount === 0) setIsCreatedByMeExpanded(true);
        if (notVisibleSharedWithMeCount === 0) setIsSharedWithMeExpanded(true);
    }, [
        notVisibleCreatedByMeCount,
        notVisibleSharedWithMeCount
    ]);
    const handleStar = (id)=>{
        update({
            defaultSavedSearchId: id
        });
    };
    return {
        isOpenCreatedByMe: isOpenCreatedByMe,
        isOpenSharedWithMe: isOpenSharedWithMe,
        setIsOpenCreatedByMe: setIsOpenCreatedByMe,
        setIsOpenSharedWithMe: setIsOpenSharedWithMe,
        selectedItemId: selectedItemId,
        handleItemClick: handleItemClick,
        isPageLoading: isPageLoading,
        starredItem: starredItem,
        expandSharedWithMe: expandSharedWithMe,
        expandCreatedByMe: expandCreatedByMe,
        isSharedWithMeExpanded: isSharedWithMeExpanded,
        isCreatedByMeExpanded: isCreatedByMeExpanded,
        createdByMeSearches: createdByMeSearches,
        sharedWithMeSearches: sharedWithMeSearches,
        notVisibleCreatedByMeCount: notVisibleCreatedByMeCount,
        notVisibleSharedWithMeCount: notVisibleSharedWithMeCount,
        defaultFilters: defaultFilters,
        handleStar: handleStar,
        openDeleteModal: openDeleteModal,
        closeDeleteModal: closeDeleteModal,
        isDeleteLoading: isDeleteLoading,
        handleDeleteModalSubmit: handleDeleteModalSubmit,
        isDeleteModalOpen: isDeleteModalOpen
    };
};

});
parcelRegister("h8yj2", function(module, exports) {

$parcel$export(module.exports, "fireAnalytics", () => $b264de6d6a035739$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $b264de6d6a035739$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $b264de6d6a035739$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $b264de6d6a035739$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireScreenAnalytics", () => $b264de6d6a035739$export$6f46fb37ad7d962b);

var $hYfgW = parcelRequire("hYfgW");


var $4zfLY = parcelRequire("4zfLY");
const $b264de6d6a035739$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $6e65040b988c460f$export$2ceccf177fae277c));
};
const $b264de6d6a035739$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $b264de6d6a035739$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $b264de6d6a035739$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$a1562d08625f5d7e), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$947dac6c72b26f81), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$12346a674644c156), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$f1d537d508d2945a), {
        attributes: attributes
    });
};

});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

parcelRegister("4zfLY", function(module, exports) {

$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $ccaec2c661eabde7$export$e6baab532ef8c6bf);
const $ccaec2c661eabde7$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $ccaec2c661eabde7$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $ccaec2c661eabde7$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $ccaec2c661eabde7$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $ccaec2c661eabde7$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});


parcelRegister("93D2l", function(module, exports) {

$parcel$export(module.exports, "getDetailUrlWithoutParams", () => $dcc80640035000dc$export$eee49ed5557d7228);
$parcel$export(module.exports, "getDetailUrl", () => $dcc80640035000dc$export$a1f31a04e28ab93e);
$parcel$export(module.exports, "getListUrl", () => $dcc80640035000dc$export$32614eb4bc529448);
$parcel$export(module.exports, "getAIViewUrl", () => $dcc80640035000dc$export$afa6dd23dfaa6ca1);

const $dcc80640035000dc$export$eee49ed5557d7228 = (alertId, teamId)=>{
    const path = teamId ? `/teams/${teamId}/alerts/${alertId || ''}` : `/alerts/${alertId || ''}`;
    return `${0, $5de925396bc7bec4$export$ca6dda5263526f75}${path}`;
};
const $dcc80640035000dc$export$a1f31a04e28ab93e = (alertId, teamId, searchedQuery)=>{
    const searchParams = new URLSearchParams({
        [(0, $5de925396bc7bec4$export$8540b2e79718c77f)]: 'detail',
        [(0, $5de925396bc7bec4$export$19f7845e9b507cf2)]: searchedQuery ?? ''
    });
    const path = teamId ? `/teams/${teamId}/alerts/${alertId || ''}` : `/alerts/${alertId || ''}`;
    return `${0, $5de925396bc7bec4$export$ca6dda5263526f75}${path}?${searchParams.toString()}`;
};
const $dcc80640035000dc$export$32614eb4bc529448 = (teamId, searchedQuery)=>{
    const searchParams = new URLSearchParams({
        [(0, $5de925396bc7bec4$export$8540b2e79718c77f)]: 'list',
        [(0, $5de925396bc7bec4$export$19f7845e9b507cf2)]: searchedQuery ?? ''
    });
    const path = teamId ? `/teams/${teamId}/alerts` : `/alerts`;
    return `${0, $5de925396bc7bec4$export$ca6dda5263526f75}${path}?${searchParams.toString()}`;
};
const $dcc80640035000dc$export$afa6dd23dfaa6ca1 = (teamId, searchedQuery)=>{
    const searchParams = new URLSearchParams({
        [(0, $5de925396bc7bec4$export$8540b2e79718c77f)]: 'ai',
        [(0, $5de925396bc7bec4$export$19f7845e9b507cf2)]: searchedQuery ?? ''
    });
    const path = teamId ? `/teams/${teamId}/alerts` : `/alerts`;
    return `${0, $5de925396bc7bec4$export$ca6dda5263526f75}${path}?${searchParams.toString()}`;
};

});
const $5de925396bc7bec4$export$19f7845e9b507cf2 = 'query';
const $5de925396bc7bec4$export$8540b2e79718c77f = 'view';
const $5de925396bc7bec4$export$d0190736add6775e = 'onlyAlerts';
const $5de925396bc7bec4$export$ca6dda5263526f75 = '/jira/ops';


parcelRegister("aF3ss", function(module, exports) {

$parcel$export(module.exports, "useSavedSearchService", () => $58a292bcee352c70$export$28d106792785721);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2YP9W = parcelRequire("2YP9W");

var $2VYEV = parcelRequire("2VYEV");

var $8eCQi = parcelRequire("8eCQi");

var $2tKfK = parcelRequire("2tKfK");

var $dyD8W = parcelRequire("dyD8W");

var $6IJKZ = parcelRequire("6IJKZ");

var $oacWJ = parcelRequire("oacWJ");
const $58a292bcee352c70$export$28d106792785721 = ()=>{
    const [isCreateLoading, setIsCreateLoading] = (0, $5uXOq.useState)(false);
    const [isDeleteLoading, setIsDeleteLoading] = (0, $5uXOq.useState)(false);
    const { showFlag: showFlag } = (0, $2tKfK.default)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const intlApi = (0, $koVbs.default)();
    const { update: update } = (0, $2YP9W.useResource)((0, $oacWJ.savedSearchesResource));
    const createSavedSearch = (data)=>{
        setIsCreateLoading(true);
        return (0, $6IJKZ.createSavedSearchEndpoint)(data).then((savedSearch)=>{
            update((savedSearches)=>({
                    ...savedSearches,
                    createdByMe: [
                        ...savedSearches.createdByMe,
                        savedSearch
                    ]
                }));
            return savedSearch;
        }).catch((error)=>{
            defaultCatch({
                id: 'useSavedSearchService-createSavedSearch',
                httpErrorHandler: (err)=>showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $dyD8W.default).errorTitle)
                    })
            }, error);
            throw error;
        }).finally(()=>{
            setIsCreateLoading(false);
        });
    };
    const deleteSavedSearch = (idToDelete)=>{
        setIsDeleteLoading(true);
        return (0, $6IJKZ.deleteSearchEndpoint)(idToDelete).then(()=>{
            update((savedSearches)=>({
                    ...savedSearches,
                    createdByMe: savedSearches.createdByMe.filter((search)=>search.id !== idToDelete),
                    sharedWithMe: savedSearches.sharedWithMe.filter((search)=>search.id !== idToDelete)
                }));
        }).catch((error)=>{
            defaultCatch({
                id: 'useSavedSearchService-handleDeleteModalSubmit',
                httpErrorHandler: (err)=>showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $dyD8W.default).errorTitle)
                    })
            }, error);
            throw error;
        }).finally(()=>{
            setIsDeleteLoading(false);
        });
    };
    return {
        createSavedSearch: createSavedSearch,
        isCreateLoading: isCreateLoading,
        isDeleteLoading: isDeleteLoading,
        deleteSavedSearch: deleteSavedSearch
    };
};

});
parcelRegister("2VYEV", function(module, exports) {

$parcel$export(module.exports, "useDefaultCatch", () => $06138e726543d489$export$3ab31fcc1d7c2589);

var $5uXOq = parcelRequire("5uXOq");

var $kmpOn = parcelRequire("kmpOn");

var $8tpNZ = parcelRequire("8tpNZ");
var $aI12f = parcelRequire("aI12f");
var $cQDa6 = parcelRequire("cQDa6");
function $06138e726543d489$export$3ab31fcc1d7c2589() {
    const reportError = (0, $cQDa6.useReportError)();
    const [error, setError] = (0, $5uXOq.useState)();
    if (error) throw error;
    return (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kmpOn)))(({ id: id, httpErrorHandler: httpErrorHandler, reporter: customReporter, attributes: attributes }, error)=>{
            if (!(0, $aI12f.isNetworkError)(error)) return setError(new (0, $8tpNZ.EocError)(id, error));
            if (customReporter !== null) {
                const reporter = customReporter ?? reportError;
                reporter(id, error, attributes);
            }
            try {
                return httpErrorHandler?.(error);
            } catch (handlerError) {
                if (!(0, $aI12f.isNetworkError)(handlerError)) setError(new (0, $8tpNZ.EocError)(id, handlerError));
                throw handlerError;
            }
        }), [
        reportError
    ]);
}

});
parcelRegister("kmpOn", function(module, exports) {

var $6CA7f = parcelRequire("6CA7f");

var $g7JQw = parcelRequire("g7JQw");
/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * Please note that default parameters don't count towards a [function arity](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/length)
 * and therefore `curry` won't work well with those:
 *
 * ```
 * const h = R.curry((a, b, c = 2) => a + b + c);
 *
 * h(40);
 * //=> function (waits for `b`)
 *
 * h(39)(1);
 * //=> 42
 *
 * h(1)(2, 3);
 * //=> 6
 *
 * h(1)(2)(7);
 * //=> Error! (`3` is not a function!)
 * ```
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $ed29e25cf476d3b2$var$curry = /*#__PURE__*/ $6CA7f(function curry(fn) {
    return $g7JQw(fn.length, fn);
});
module.exports = $ed29e25cf476d3b2$var$curry;

});
parcelRegister("6CA7f", function(module, exports) {

var $dtL0L = parcelRequire("dtL0L");
/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $4d224e922cc0a345$var$_curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || $dtL0L(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
module.exports = $4d224e922cc0a345$var$_curry1;

});
parcelRegister("dtL0L", function(module, exports) {
function $9d027343e6afec73$var$_isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
module.exports = $9d027343e6afec73$var$_isPlaceholder;

});


parcelRegister("g7JQw", function(module, exports) {

var $dxgtl = parcelRequire("dxgtl");

var $6CA7f = parcelRequire("6CA7f");

var $18myW = parcelRequire("18myW");

var $90GZI = parcelRequire("90GZI");
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $bbd0dce5f5e12876$var$curryN = /*#__PURE__*/ $18myW(function curryN(length, fn) {
    if (length === 1) return $6CA7f(fn);
    return $dxgtl(length, $90GZI(length, [], fn));
});
module.exports = $bbd0dce5f5e12876$var$curryN;

});
parcelRegister("dxgtl", function(module, exports) {
function $9dab227b64b88e13$var$_arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}
module.exports = $9dab227b64b88e13$var$_arity;

});

parcelRegister("18myW", function(module, exports) {

var $6CA7f = parcelRequire("6CA7f");

var $dtL0L = parcelRequire("dtL0L");
/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $0d380a4094fa43af$var$_curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return $dtL0L(a) ? f2 : $6CA7f(function(_b) {
                    return fn(a, _b);
                });
            default:
                return $dtL0L(a) && $dtL0L(b) ? f2 : $dtL0L(a) ? $6CA7f(function(_a) {
                    return fn(_a, b);
                }) : $dtL0L(b) ? $6CA7f(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
module.exports = $0d380a4094fa43af$var$_curry2;

});

parcelRegister("90GZI", function(module, exports) {

var $dxgtl = parcelRequire("dxgtl");

var $dtL0L = parcelRequire("dtL0L");
/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $01b160e2e45af68a$var$_curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!$dtL0L(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!$dtL0L(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : $dxgtl(left, $01b160e2e45af68a$var$_curryN(length, combined, fn));
    };
}
module.exports = $01b160e2e45af68a$var$_curryN;

});



parcelRegister("8tpNZ", function(module, exports) {

$parcel$export(module.exports, "EocError", () => $d534eb2e187b068b$export$e76fc0e0bc06f4df);
function $d534eb2e187b068b$var$hasMessage(cause) {
    return typeof cause === 'object' && cause !== null && 'message' in cause;
}
class $d534eb2e187b068b$export$e76fc0e0bc06f4df extends Error {
    constructor(id, cause){
        super(`[${id}] ${$d534eb2e187b068b$var$hasMessage(cause) ? cause.message : cause}`), this.id = id, this.cause = cause;
        this.name = 'EocError';
    }
}

});

parcelRegister("cQDa6", function(module, exports) {

$parcel$export(module.exports, "useReportError", () => $c58a665a3c6a26b3$export$5a5695b638d078e7);

var $5uXOq = parcelRequire("5uXOq");

var $aI12f = parcelRequire("aI12f");

var $74BDp = parcelRequire("74BDp");
function $c58a665a3c6a26b3$export$cad78388f408899e(error) {
    if (!(0, $aI12f.isNetworkError)(error)) return true;
    return !(0, $aI12f.isHTTPError)(error);
}
const $c58a665a3c6a26b3$export$5a5695b638d078e7 = ()=>{
    const { reporterAction: reporterAction } = (0, $74BDp.useGlobalContextActions)();
    return (0, $5uXOq.useMemo)(()=>(id, error, attributes)=>{
            if (!$c58a665a3c6a26b3$export$cad78388f408899e(error)) return;
            reporterAction({
                id: id,
                error: error,
                attributes: attributes
            });
        }, [
        reporterAction
    ]);
};

});
parcelRegister("74BDp", function(module, exports) {

$parcel$export(module.exports, "GlobalContextContainer", () => $aca7a4d9aea0d818$export$8a0b5f75aa4dc446);
$parcel$export(module.exports, "useExternalFlagService", () => $aca7a4d9aea0d818$export$6b9ad8a324c94098);
$parcel$export(module.exports, "useSendMessage", () => $aca7a4d9aea0d818$export$fe8707b58c509543);
$parcel$export(module.exports, "useGlobalContextActions", () => $aca7a4d9aea0d818$export$8a9eff51cb8da29e);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $bMb9B = parcelRequire("bMb9B");
const $aca7a4d9aea0d818$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'global-context',
    initialState: {
        reporter: undefined
    },
    actions: $bMb9B
});
const $aca7a4d9aea0d818$export$8a0b5f75aa4dc446 = ({ flagService: flagService, reporter: reporter, children: children, messages: messages, config: config })=>{
    const { locale: locale } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aca7a4d9aea0d818$var$OriginalGlobalContextContainer, {
        config: config,
        reporter: reporter,
        isGlobal: true,
        flagService: flagService
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
        locale: locale,
        messages: messages && messages[locale]
    }, children));
};
const $aca7a4d9aea0d818$var$OriginalGlobalContextContainer = (0, $gg7kZ.createContainer)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
    onInit: ()=>async ({ getState: getState, setState: setState }, { flagService: flagService, config: config })=>{
            !getState().flagService && setState({
                flagService: flagService
            });
            if (config?.context) setState({
                config: {
                    ...getState().config,
                    context: config.context
                }
            });
            if (config?.messageHandler) setState({
                config: {
                    ...getState().config,
                    messageHandler: config.messageHandler
                }
            });
        },
    onUpdate: ()=>async ({ getState: getState, setState: setState }, { config: config })=>{
            if (config?.context) setState({
                config: {
                    ...getState().config,
                    context: config.context
                }
            });
            if (config?.messageHandler) setState({
                config: {
                    ...getState().config,
                    messageHandler: config.messageHandler
                }
            });
        }
});
const $aca7a4d9aea0d818$export$2041a7a7b51b1fce = (0, $51nlc.createSubscriber)($aca7a4d9aea0d818$export$390f32400eaf98c9);
const $aca7a4d9aea0d818$export$6b9ad8a324c94098 = (0, $3sQ5x.createHook)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
    selector: (state)=>state.flagService
});
const $aca7a4d9aea0d818$export$fe8707b58c509543 = (handlerClass)=>{
    const [{ handler: handler, context: context }] = $aca7a4d9aea0d818$var$useSendMessageInternal(handlerClass);
    return (params)=>{
        return handler(params, context);
    };
};
const $aca7a4d9aea0d818$var$useSendMessageInternal = (0, $3sQ5x.createHook)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
    selector: (state, arg)=>{
        if (state.config && state.config.messageHandler && state.config.messageHandler instanceof arg) return {
            handler: state.config.messageHandler.handler.bind(state.config.messageHandler),
            context: state.config.context
        };
        throw new Error(`The messageHandler provided from nearest GlobalContextContainer doesn't implement the one from the inner tree. Please make sure you have a compatible GlobalContextContainer`);
    }
});
const $aca7a4d9aea0d818$export$8a9eff51cb8da29e = (0, $3sQ5x.createActionsHook)($aca7a4d9aea0d818$export$390f32400eaf98c9);

});
parcelRegister("bMb9B", function(module, exports) {

$parcel$export(module.exports, "reporterAction", () => $3a0e18e647f4c498$export$f3910000817a36c2);
$parcel$export(module.exports, "getHorizontalNav", () => $3a0e18e647f4c498$export$7c79a3553de2e8e7);
const $3a0e18e647f4c498$export$f3910000817a36c2 = ({ id: id, error: error, attributes: attributes })=>({}, { reporter: reporter })=>{
        if (reporter) {
            reporter({
                id: id,
                error: error,
                attributes: attributes
            });
            return;
        }
    };
const $3a0e18e647f4c498$export$7c79a3553de2e8e7 = ()=>({}, { config: config })=>{
        return config?.isNewNavigation || false;
    };

});




parcelRegister("8eCQi", function(module, exports) {

$parcel$export(module.exports, "errorToastProps", () => $06a51a880a3faae2$export$c37f1e5051cd0bbc);
$parcel$export(module.exports, "warningToastProps", () => $06a51a880a3faae2$export$fe81a150e4e6ac02);
$parcel$export(module.exports, "infoToastProps", () => $06a51a880a3faae2$export$e70d6574d157a39b);
$parcel$export(module.exports, "successToastProps", () => $06a51a880a3faae2$export$b56198a940066d8f);

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");


var $2bUsm = parcelRequire("2bUsm");
const $06a51a880a3faae2$var$ErrorWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).error)
    }));
const $06a51a880a3faae2$var$WarningWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).warning)
    }));
const $06a51a880a3faae2$var$InfoWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        color: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).info)
    }));
const $06a51a880a3faae2$var$SuccessWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).success)
    }));
const $06a51a880a3faae2$export$c37f1e5051cd0bbc = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$ErrorWithIntl, null),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$fe81a150e4e6ac02 = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$WarningWithIntl, null),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$e70d6574d157a39b = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$InfoWithIntl, null),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$b56198a940066d8f = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$SuccessWithIntl, null),
        appearance: 'normal',
        isAutoDismiss: true
    });

});
parcelRegister("1jWct", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e457cb24ac9ea7300ef511f2118ffa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f64b62884a9bedb$var$_react = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0f64b62884a9bedb$var$_information = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2Yv61")));

var $0f64b62884a9bedb$var$_info = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2hXfb")));
function $0f64b62884a9bedb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f64b62884a9bedb$var$InformationIcon = (props)=>/*#__PURE__*/ $0f64b62884a9bedb$var$_react.default.createElement($0f64b62884a9bedb$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $0f64b62884a9bedb$var$_info.default
    }, props));
$0f64b62884a9bedb$var$InformationIcon.Name = 'InformationIconMigration';
var $0f64b62884a9bedb$var$_default = module.exports.default = $0f64b62884a9bedb$var$InformationIcon;

});

parcelRegister("c2i4s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b4b1d8f8ae82590ab9e3b231233297b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c33b074f80a91d5$var$_react = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8c33b074f80a91d5$var$_success = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("b0JGA")));

var $8c33b074f80a91d5$var$_checkCircle = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("btivG")));
function $8c33b074f80a91d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c33b074f80a91d5$var$SuccessIcon = (props)=>/*#__PURE__*/ $8c33b074f80a91d5$var$_react.default.createElement($8c33b074f80a91d5$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $8c33b074f80a91d5$var$_checkCircle.default
    }, props));
$8c33b074f80a91d5$var$SuccessIcon.Name = 'SuccessIconMigration';
var $8c33b074f80a91d5$var$_default = module.exports.default = $8c33b074f80a91d5$var$SuccessIcon;

});

parcelRegister("2bUsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7145ce6f0cfaef60$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7145ce6f0cfaef60$var$messages = (0, $7VHMR.defineMessages)({
    error: {
        id: 'eoc.common.toast.error',
        defaultMessage: 'Error',
        description: 'The title for an error as a single word.'
    },
    warning: {
        id: 'eoc.common.toast.warning',
        defaultMessage: 'Warning',
        description: 'The title for a warning as a single word.'
    },
    success: {
        id: 'eoc.common.toast.success',
        defaultMessage: 'Success',
        description: 'The title for success as a single word.'
    },
    info: {
        id: 'eoc.common.toast.info',
        defaultMessage: 'Information',
        description: 'The title for an information as a single word.'
    }
});
var $7145ce6f0cfaef60$export$2e2bcd8739ae039 = $7145ce6f0cfaef60$var$messages;

});


parcelRegister("2tKfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c357df09fe3f96fe$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $fWXJB = parcelRequire("fWXJB");
var $epfFv = parcelRequire("epfFv");
var $bKCvK = parcelRequire("bKCvK");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $74BDp = parcelRequire("74BDp");
const $c357df09fe3f96fe$var$useFlags = ()=>{
    const [flagService] = (0, $74BDp.useExternalFlagService)();
    const serviceRef = (0, $5uXOq.useRef)(flagService);
    (0, $hmVmJ.assert)(!serviceRef.current || !!flagService, new (0, $dH6Pi.AssertionError)('GlobalContext', 'flagService was destroyed.'));
    return serviceRef.current !== undefined ? {
        showFlag: ({ isAutoDismiss: isAutoDismiss, ...props })=>{
            const Component = ({ id: id, onDismissed: onDismissed })=>{
                if (isAutoDismiss) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fWXJB.default), {
                    ...props,
                    id: id,
                    onDismissed: (id, e)=>{
                        onDismissed(id.toString());
                        props.onDismissed?.(id, e);
                    }
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epfFv.default), {
                    ...props,
                    id: id,
                    onDismissed: (id, e)=>{
                        onDismissed(id.toString());
                        props.onDismissed?.(id, e);
                    }
                });
            };
            const id = (0, $7Jxgt.v4)();
            Component.id = id;
            serviceRef.current.showFlag(Component);
            return ()=>{
                serviceRef.current.dismissFlag({
                    id: id,
                    command: 'DISMISS'
                });
            };
        }
    } : //eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $bKCvK.useFlags)();
};
var $c357df09fe3f96fe$export$2e2bcd8739ae039 = $c357df09fe3f96fe$var$useFlags;

});

parcelRegister("dyD8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c9c60f19f1eb35b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $1c9c60f19f1eb35b$var$messages = (0, $7VHMR.defineMessages)({
    errorTitle: {
        id: 'eoc.alert-list.flag.error-title.no-translate',
        defaultMessage: 'Error',
        description: 'Title of error message that will be displayed in the flag'
    },
    successTitle: {
        id: 'eoc.alert-list.flag.success-title.no-translate',
        defaultMessage: 'Success',
        description: 'Title of success message that will be displayed in the flag'
    },
    acknowledge: {
        id: 'eoc.alert-list.actions.acknowledge.no-translate',
        defaultMessage: 'Ack',
        description: 'Acknowledge action button'
    },
    unacknowledge: {
        id: 'eoc.alert-list.actions.unacknowledge.no-translate',
        defaultMessage: 'Open',
        description: 'Unacknowledge(open) action button'
    },
    snooze: {
        id: 'eoc.alert-list.actions.snooze.no-translate',
        defaultMessage: 'Snooze',
        description: 'Snooze action button'
    },
    close: {
        id: 'eoc.alert-list.actions.close.no-translate',
        defaultMessage: 'Close',
        description: 'Close action button'
    },
    delete: {
        id: 'eoc.alert-list.actions.delete.no-translate',
        defaultMessage: ' Delete',
        description: 'Delete action button'
    },
    escalateToNext: {
        id: 'eoc.alert-list.actions.escalateToNext.no-translate',
        defaultMessage: 'Escalate to next',
        description: 'Escalate to next action button'
    },
    assign: {
        id: 'eoc.alert-list.actions.assign.no-translate',
        defaultMessage: 'Assign',
        description: 'Assign action button'
    },
    addResponder: {
        id: 'eoc.alert-list.actions.add-responder.no-translate',
        defaultMessage: 'Add responder',
        description: 'Add responder action button'
    },
    takeOwnership: {
        id: 'eoc.alert-list.actions.takeOwnership.no-translate',
        defaultMessage: 'Assign to me',
        description: 'Assign to me action button'
    },
    addTag: {
        id: 'eoc.alert-list.actions.add-tag.no-translate',
        defaultMessage: 'Add tag',
        description: 'Add tag action button'
    },
    addNote: {
        id: 'eoc.alert-list.actions.add-note.no-translate',
        defaultMessage: 'Add note',
        description: 'Add note action button'
    },
    empty: {
        id: `eoc.alert-list.empty.no-translate`,
        defaultMessage: 'No matching alerts were found.',
        description: 'Alerts can be symptoms of potential incidents or issues. Integrate your applications so you never miss a critical alert.'
    },
    noAlerts: {
        id: `eoc.alert-list.no-alerts.no-translate`,
        defaultMessage: "You don\u2019t have any alerts, yet",
        description: 'Message displayed when there is no alerts'
    },
    learnMore: {
        id: `eoc.alert-list.no-alerts.learn-more.no-translate`,
        defaultMessage: 'Read how alerts are created',
        description: 'Message displayed for redirecting user to alert create docs'
    },
    emptyDescription: {
        id: `eoc.alert-list.no-alerts.description.no-translate`,
        defaultMessage: "We couldn\u2019t find any alerts for this search. Change your filters and try again.",
        description: 'Message displayed as description when there is no alerts with given search'
    },
    noAlertsDescription: {
        id: `eoc.alert-list.no-alerts.description.no-translate`,
        defaultMessage: 'Alerts can be symptoms of potential incidents or issues. Integrate your applications so you never miss a critical alert.',
        description: 'Message displayed when there is no alerts'
    },
    error: {
        id: `eoc.alert-list.error.no-translate`,
        defaultMessage: "We couldn\u2019t load the alerts",
        description: 'Message displayed when there is an error on fetching alerts'
    },
    errorDescription: {
        id: `eoc.alert-list.error.description.no-translate`,
        defaultMessage: 'Something went wrong while we were loading the alerts. Try searching again.',
        description: 'Message displayed as description when there is an error on fetching alerts'
    },
    pageTitle: {
        id: 'eoc.alert-list.page.title.no-translate',
        defaultMessage: 'Alerts',
        description: 'Title of the page'
    },
    emptyAIViewTitle: {
        id: 'eoc.alert-list.flag.error-title.no-translate',
        defaultMessage: 'Looking for alerts to group',
        description: 'Title ofthe message that will be displayed when no groups are present'
    },
    emptyAIViewDescription: {
        id: 'eoc.alert-list.flag.success-title.no-translate',
        defaultMessage: 'Atlassian Intelligence is working behind the scenes and will update this space as soon as new groups are identified.',
        description: 'Description of the message that will be displayed when no groups are present'
    },
    dareAIViewTitle: {
        id: 'eoc.alert-list.flag.dare-title.no-translate',
        defaultMessage: 'Starting fresh to group alerts',
        description: 'Title of the message that will be displayed when no groups are present because of DaRe'
    },
    dareAIViewDescription: {
        id: 'eoc.alert-list.flag.dare-description.no-translate',
        defaultMessage: 'Since you changed your data residency location, previous alert groups were deleted. Atlassian Intelligence is working behind the scenes and will update this space as soon as new groups are identified.',
        description: 'Description of the message that will be displayed when no groups are present'
    },
    notEnabledAIViewTitle: {
        id: 'eoc.smart-alert-list.flag.not-enabled.no-translate',
        defaultMessage: "We couldn\u2019t find what you\u2019re looking for",
        description: 'Title of the message that will be displayed when AI view is not enabled'
    },
    notEnabledAIViewDescription: {
        id: 'eoc.smart-alert-list.flag.not-enabled.no-translate',
        defaultMessage: "We looked everywhere, but it doesn\u2019t exist.",
        description: 'Description of the message that will be displayed when AI view is not enabled'
    },
    readMoreAlertGrouping: {
        id: 'eoc.alert-list.flag.success-title.no-translate',
        defaultMessage: 'Read more about alert grouping',
        description: 'Message for read more that will be displayed when no groups are present'
    },
    requiredFieldsInformMessage: {
        id: 'eoc.alert-list.modal.required-fields-inform-message.no-translate',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Message to give information to users about required fields'
    },
    ariaLiveMessageFilters: {
        id: `eoc.alert-list.filters.aria-live-message.no-translate`,
        defaultMessage: `{removedValue, select,
      true { Option {label} deselected. {numOfAlerts} matching alerts found. }
      other { Option {label} selected. {numOfAlerts} matching alerts found. }
    }`,
        description: 'The message to be announced when user selects an option from one of the filters.'
    },
    buttonAriaLabelToIndicateTableModification: {
        id: `eoc.alert-list.filters.update-button.no-translate`,
        defaultMessage: '{buttonText}. The table will be modified.',
        description: 'The message to be announced before user press update filter button.'
    }
});
var $1c9c60f19f1eb35b$export$2e2bcd8739ae039 = $1c9c60f19f1eb35b$var$messages;

});


parcelRegister("7oBCJ", function(module, exports) {

$parcel$export(module.exports, "useUiPreferencesService", () => $b0f804f30bcb3777$export$c23514c95cddcbd8);

var $koVbs = parcelRequire("koVbs");

var $2VYEV = parcelRequire("2VYEV");

var $8eCQi = parcelRequire("8eCQi");

var $2tKfK = parcelRequire("2tKfK");

var $hem2I = parcelRequire("hem2I");

var $dyD8W = parcelRequire("dyD8W");

var $fY9nC = parcelRequire("fY9nC");

var $dqLIo = parcelRequire("dqLIo");
const $b0f804f30bcb3777$var$defaultUiPreferences = {
    defaultSavedSearchId: '',
    alertListTime: {
        range: 'all'
    },
    lastSearchedQuery: '',
    alertListType: 'cozy',
    alertListSortField: 'insertedAt',
    canSeeAllAlerts: false,
    visibilityFilterToggle: false,
    uvShowAlertGroups: false
};
const $b0f804f30bcb3777$export$c23514c95cddcbd8 = ()=>{
    const { showFlag: showFlag } = (0, $2tKfK.default)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const { data: data, update: update, loading: loading } = (0, $hem2I.default)((0, $dqLIo.uiPreferencesResource));
    const updateUiPreferences = (data)=>{
        update((state)=>({
                ...state,
                ...data
            }));
        return (0, $fY9nC.updateUiPreferencesEndpoint)(data).catch(defaultCatch({
            id: 'useUiPreferencesService-update',
            httpErrorHandler: (err)=>{
                showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    description: err.message,
                    title: formatMessage((0, $dyD8W.default).errorTitle)
                });
            }
        }));
    };
    return {
        data: data ?? $b0f804f30bcb3777$var$defaultUiPreferences,
        isLoading: loading,
        update: updateUiPreferences
    };
};

});
parcelRegister("hem2I", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf0b5f2d38c9a8bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2YP9W = parcelRequire("2YP9W");

var $gIuON = parcelRequire("gIuON");

var $8tpNZ = parcelRequire("8tpNZ");
var $aI12f = parcelRequire("aI12f");
var $cQDa6 = parcelRequire("cQDa6");
const $bf0b5f2d38c9a8bd$var$useEocResource = (routeResource, options)=>{
    const reporter = (0, $cQDa6.useReportError)();
    const resource = (0, $2YP9W.useResource)(routeResource, options);
    const { error: error } = resource;
    (0, $5uXOq.useEffect)(()=>{
        if (!error) return;
        const id = routeResource.type;
        if ((0, $gIuON.isServer)() || (0, $aI12f.isNetworkError)(error)) reporter(id, error);
        else throw new (0, $8tpNZ.EocError)(id, error);
    }, [
        error,
        reporter,
        routeResource.type
    ]);
    // User always responsible for rendering an appropriate error view on jsx.
    // Thus, we return RouteResource at the end.
    // Also, it is default behaviour if there is no error.
    return resource;
};
var $bf0b5f2d38c9a8bd$export$2e2bcd8739ae039 = $bf0b5f2d38c9a8bd$var$useEocResource;

});



parcelRegister("9ftda", function(module, exports) {

$parcel$export(module.exports, "LoadingRow", () => $ebc776be80a4c97c$export$d1e723d3001badba);

var $5uXOq = parcelRequire("5uXOq");

var $8icyj = parcelRequire("8icyj");

var $gn2dU = parcelRequire("gn2dU");
const $ebc776be80a4c97c$export$d1e723d3001badba = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gn2dU.StyledFlex), {
        columnGap: 3,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        width: 19.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        width: 3
    }));
};

});
parcelRegister("8icyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c1f30f978a2dd2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $66W34 = parcelRequire("66W34");
const $35c1f30f978a2dd2$var$defaultDimensions = {
    line: [
        24,
        1.5
    ],
    circle: [
        3,
        3
    ],
    square: [
        3,
        3
    ]
};
const $35c1f30f978a2dd2$var$Skeleton = ({ width: width, height: height, variant: variant = 'line' })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $66W34.StyledWrapper), {
        variant: variant,
        dimensions: {
            width: width ?? $35c1f30f978a2dd2$var$defaultDimensions[variant][0],
            height: height ?? $35c1f30f978a2dd2$var$defaultDimensions[variant][1]
        },
        "data-testid": "eoc-skeleton"
    });
var $35c1f30f978a2dd2$export$2e2bcd8739ae039 = $35c1f30f978a2dd2$var$Skeleton;

});
parcelRegister("66W34", function(module, exports) {

$parcel$export(module.exports, "StyledWrapper", () => $9529eb8091350071$export$1f99da106a398c44);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $k5uoT = parcelRequire("k5uoT");

var $bWGt6 = parcelRequire("bWGt6");
const $9529eb8091350071$var$colors = {
    base: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
    shimmer: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`
};
/**
 * @param val specifies the dimension value before conversion
 * @returns the CSS value for dimension
 */ const $9529eb8091350071$var$getDimensionValue = (val)=>{
    return typeof val === 'string' ? val : `${(0, $k5uoT.gridSize)() * val}px`;
};
const $9529eb8091350071$var$waveKeyframes = (0, $f8Sb3.keyframes)({
    '0%': {
        backgroundPosition: '-400px 0'
    },
    '100%': {
        backgroundPosition: '400px 0'
    }
});
const $9529eb8091350071$export$1f99da106a398c44 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1s9j7ip0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ dimensions: dimensions })=>{
    return {
        display: 'block',
        backgroundColor: $9529eb8091350071$var$colors.base,
        background: `linear-gradient(to right, ${$9529eb8091350071$var$colors.base} 10%, ${$9529eb8091350071$var$colors.shimmer} 25%, ${$9529eb8091350071$var$colors.base} 40%)`,
        backgroundSize: '800px 64px',
        width: $9529eb8091350071$var$getDimensionValue(dimensions.width),
        height: $9529eb8091350071$var$getDimensionValue(dimensions.height),
        animation: `${$9529eb8091350071$var$waveKeyframes} 1.25s linear infinite forwards`,
        borderRadius: '4px',
        flexShrink: 0
    };
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ variant: variant })=>{
    if (variant === 'line') return {
        flexShrink: 1
    };
    if (variant === 'circle') return {
        borderRadius: '100%'
    };
});

});


parcelRegister("gn2dU", function(module, exports) {

$parcel$export(module.exports, "StyledFlex", () => $37940cf91bfbcc4c$export$a55749bd318314a5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $37940cf91bfbcc4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $37940cf91bfbcc4c$export$a55749bd318314a5 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e15i02ll0"
})({
    name: "1mgmgtn",
    styles: "height:var(--ds-space-500, 40px)"
});

});


parcelRegister("cp8tc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b79be0d2eee21049$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $b79be0d2eee21049$var$messages = (0, $7VHMR.defineMessages)({
    starred: {
        id: 'eoc.alert-list.saved-searches.starred-section.no-translate',
        defaultMessage: 'Starred',
        description: 'Section title in alert list navigation.'
    },
    starTooltip: {
        id: 'eoc.alert-list.saved-searches.star.tooltip.no-translate',
        defaultMessage: 'Add to Starred',
        description: 'Tooltip will be displayed on star icon'
    },
    deleteTooltip: {
        id: 'eoc.alert-list.saved-searches.delete.tooltip.no-translate',
        defaultMessage: 'Delete',
        description: 'Tooltip will be displayed on delete icon'
    },
    unstarTooltip: {
        id: 'eoc.alert-list.saved-searches.unstar.tooltip.no-translate',
        defaultMessage: 'Remove from Starred',
        description: 'Tooltip will be displayed on unstar icon'
    },
    starredEmpty: {
        id: 'eoc.alert-list.saved-searches.starred-section.empty.no-translate',
        defaultMessage: 'Select the star icon next to your queues to add them here.',
        description: 'The text will be displayed inside starred section when there is no item'
    },
    sharedWithMeEmpty: {
        id: 'eoc.alert-list.saved-searches.shared-with-me-section.empty.no-translate',
        defaultMessage: "When a team member saves a search you'll see them here.",
        description: 'The text will be displayed inside shared with me section when there is no item'
    },
    createdByMeEmpty: {
        id: 'eoc.alert-list.saved-searches.created-by-me-section.empty.no-translate',
        defaultMessage: 'Your saved searches will appear here.',
        description: 'The text will be displayed inside created by me section when there is no item'
    },
    filters: {
        id: 'eoc.alert-list.saved-searches.filters-section.no-translate',
        defaultMessage: 'Default Filters',
        description: 'Section title in alert list navigation.'
    },
    sharedWithMe: {
        id: 'eoc.alert-list.saved-searches.shared-with-me-section.no-translate',
        defaultMessage: 'Shared with me',
        description: 'Section title in alert list navigation.'
    },
    createdByMe: {
        id: 'eoc.alert-list.saved-searches.created-by-me-section.no-translate',
        defaultMessage: 'Saved searches',
        description: 'Section title in alert list navigation.'
    },
    allSearch: {
        id: 'eoc.alert-list.saved-searches.all-search.no-translate',
        defaultMessage: 'All',
        description: 'Predefined search query in the alert list navigation.'
    },
    openSearch: {
        id: 'eoc.alert-list.saved-searches.open-search.no-translate',
        defaultMessage: 'Open',
        description: 'Predefined search query in the alert list navigation.'
    },
    closedSearch: {
        id: 'eoc.alert-list.saved-searches.closed-search.no-translate',
        defaultMessage: 'Closed',
        description: 'Predefined search query in the alert list navigation.'
    },
    unackedSearch: {
        id: 'eoc.alert-list.saved-searches.unacked-search.no-translate',
        defaultMessage: 'Unacknowledged',
        description: 'Predefined search query in the alert list navigation.'
    },
    notSeenSearch: {
        id: 'eoc.alert-list.saved-searches.not-seen-search.no-translate',
        defaultMessage: 'Not seen',
        description: 'Predefined search query in the alert list navigation.'
    },
    assignedToMeSearch: {
        id: 'eoc.alert-list.saved-searches.assigned.no-translate',
        defaultMessage: 'Assigned to me',
        description: 'Predefined search query in the alert list navigation.'
    },
    moreText: {
        id: 'eoc.alert-list.saved-searches.more-text.no-translate',
        defaultMessage: '+{count} more',
        description: 'Text will be displayed as see more with count'
    },
    starIconLabel: {
        id: 'eoc.alert-list.saved-searches.star.no-translate',
        defaultMessage: 'Star',
        description: 'Text is the label of action which star the saved search'
    },
    deleteIconLabel: {
        id: 'eoc.alert-list.saved-searches.delete.no-translate',
        defaultMessage: 'Delete',
        description: 'Text is the label of action which delete the saved search'
    },
    deleteModalTitle: {
        id: 'eoc.alert-list.saved-searches.delete-modal.title.no-translate',
        defaultMessage: 'Deleting saved search',
        description: 'Delete saved search modal title'
    },
    deleteModalDescription: {
        id: 'eoc.alert-list.saved-searches.delete-modal.description.no-translate',
        defaultMessage: "You\u2019re permanently deleting the saved search.",
        description: 'Description inside delete modal body.'
    }
});
var $b79be0d2eee21049$export$2e2bcd8739ae039 = $b79be0d2eee21049$var$messages;

});

parcelRegister("3IyOX", function(module, exports) {

$parcel$export(module.exports, "StyledExpandableSection", () => $078ad95f50136c57$export$2040436cadb473cf);
$parcel$export(module.exports, "StyledExpandableSectionTitle", () => $078ad95f50136c57$export$4e15ffdac2c7b3d6);
$parcel$export(module.exports, "StyledMoreText", () => $078ad95f50136c57$export$4bc18ad3549cd5f8);
$parcel$export(module.exports, "StyledButtonItem", () => $078ad95f50136c57$export$b584e859d6d50685);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $ayWDM = parcelRequire("ayWDM");


var $kugKu = parcelRequire("kugKu");

var $bWGt6 = parcelRequire("bWGt6");
function $078ad95f50136c57$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $078ad95f50136c57$export$2040436cadb473cf = /*#__PURE__*/ (0, $bWGt6.default)((0, $kugKu.Section), {
    target: "e155u24w3"
})({
    name: "13dd600",
    styles: "margin-top:var(--ds-space-200, 16px);margin-bottom:var(--ds-space-250, 20px)"
});
const $078ad95f50136c57$export$4e15ffdac2c7b3d6 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e155u24w2"
})({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtle, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`,
    margin: `0 0 0 ${"var(--ds-space-negative-100, -8px)"}`
});
const $078ad95f50136c57$export$4bc18ad3549cd5f8 = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e155u24w1"
})({
    name: "127p4j5",
    styles: "margin-top:0;padding:var(--ds-space-100, 8px);color:var(--ds-text-information, #0055CC);cursor:pointer"
});
const $078ad95f50136c57$export$b584e859d6d50685 = /*#__PURE__*/ (0, $bWGt6.default)((0, $ayWDM.default), {
    target: "e155u24w0"
})({
    name: "188r3y6",
    styles: "&:not(:hover, :focus, :active, :focus-visible, :focus-within){.action-wrapper{visibility:hidden;}}margin-bottom:var(--ds-space-025, 2px)"
});

});
parcelRegister("kugKu", function(module, exports) {

$parcel$export(module.exports, "Section", () => $9e61b360cb4bd65a$export$6e2c8f0811a474ce);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dY87H = parcelRequire("dY87H");

var $cBYaP = parcelRequire("cBYaP");

var $ctlOM = parcelRequire("ctlOM");
const $9e61b360cb4bd65a$var$hiddenContentStyles = (0, $8CUq3.xcss)({
    display: 'none'
});
const $9e61b360cb4bd65a$export$6e2c8f0811a474ce = ({ children: children, className: className, ...props })=>{
    const id = (0, $5uXOq.useMemo)((0, $cBYaP.getNextId), []);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        flexDirection: "column",
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctlOM.Header), {
        ...props,
        sectionId: id
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        id: `${id}-content`,
        xcss: props.isOpen === false && $9e61b360cb4bd65a$var$hiddenContentStyles,
        role: "region",
        "aria-labelledby": `${id}-header`
    }, children)));
};

});
parcelRegister("cBYaP", function(module, exports) {

$parcel$export(module.exports, "getNextId", () => $a83b9c01083da39e$export$bfc4ad7c1c5887fd);
let $a83b9c01083da39e$var$idCounter = 0;
function $a83b9c01083da39e$export$bfc4ad7c1c5887fd() {
    return `section-${++$a83b9c01083da39e$var$idCounter}`;
}

});

parcelRegister("ctlOM", function(module, exports) {

$parcel$export(module.exports, "Header", () => $09de9357ccbb472b$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $c8Oei = parcelRequire("c8Oei");

var $hWZau = parcelRequire("hWZau");

var $dY87H = parcelRequire("dY87H");

var $cHv2c = parcelRequire("cHv2c");
const $09de9357ccbb472b$export$8b251419efc915eb = ({ sectionId: sectionId, isOpen: isOpen, title: title, actions: actions, info: info, alignTitleToContainer: alignTitleToContainer, alignHeaderItems: alignHeaderItems = 'center', sectionDirection: sectionDirection, onClick: onClick, className: className, headerRole: headerRole })=>{
    const isCollapsible = (0, $5uXOq.useMemo)(()=>typeof isOpen !== 'undefined', [
        isOpen
    ]);
    const ChevronWrapper = alignTitleToContainer ? (0, $cHv2c.StyledChevronWrapper) : (0, $5uXOq.Fragment);
    const InfoWrapper = sectionDirection === 'column' ? (0, $5uXOq.Fragment) : (0, $cHv2c.SectionInfo);
    const handleKeyDown = (event)=>{
        if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            onClick?.();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        flexDirection: sectionDirection,
        flexGrow: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHv2c.SectionHeader), {
        alignItems: alignHeaderItems,
        onClick: onClick,
        columnGap: alignTitleToContainer ? 0 : 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        isCollapsible: isCollapsible,
        "aria-expanded": !headerRole ? isOpen : undefined,
        role: headerRole ?? 'button',
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        id: `${sectionId}-header`,
        "aria-controls": `${sectionId}-content`
    }, isCollapsible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChevronWrapper, null, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        color: "currentColor",
        spacing: "spacious",
        testId: "opened-section-chevron",
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
        color: "currentColor",
        spacing: "spacious",
        testId: "closed-section-chevron",
        label: ""
    })), typeof title === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHv2c.SectionTitle), null, title) : title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InfoWrapper, null, info)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        alignItems: "center"
    }, actions));
};

});
parcelRegister("cHv2c", function(module, exports) {

$parcel$export(module.exports, "StyledChevronWrapper", () => $8232d529454e7b1e$export$4ea0afaee716a881);
$parcel$export(module.exports, "SectionTitle", () => $8232d529454e7b1e$export$69bc41ee738923ec);
$parcel$export(module.exports, "SectionHeader", () => $8232d529454e7b1e$export$8adb256d999cd5a0);
$parcel$export(module.exports, "SectionInfo", () => $8232d529454e7b1e$export$3cc22bc1e76aaeab);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $8232d529454e7b1e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8232d529454e7b1e$export$4ea0afaee716a881 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eqlwngz3"
})({
    name: "z6azkj",
    styles: "width:24px;height:24px;margin-left:var(--ds-space-negative-300, -24px)"
});
const $8232d529454e7b1e$export$69bc41ee738923ec = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eqlwngz2"
})({
    name: "1paz1du",
    styles: "font:var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
});
const $8232d529454e7b1e$export$8adb256d999cd5a0 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "eqlwngz1"
})("width:100%;flex-basis:content;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isCollapsible: isCollapsible })=>isCollapsible && 'cursor: pointer;');
const $8232d529454e7b1e$export$3cc22bc1e76aaeab = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eqlwngz0"
})({
    name: "1ncdxoc",
    styles: "align-self:center;margin-left:var(--ds-space-100, 8px)"
});

});





parcelRegister("3mHCV", function(module, exports) {

$parcel$export(module.exports, "Sidebar", () => $f32d54c244692341$export$1ba59dacbcbf90fe);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $jSfqD = parcelRequire("jSfqD");
var $juVrZ = parcelRequire("juVrZ");
var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $h8yj2 = parcelRequire("h8yj2");

var $gIuON = parcelRequire("gIuON");

var $dY87H = parcelRequire("dY87H");

var $ckGBu = parcelRequire("ckGBu");

var $iZ8yx = parcelRequire("iZ8yx");

var $brUQK = parcelRequire("brUQK");

var $eZtqT = parcelRequire("eZtqT");

var $XLMJ8 = parcelRequire("XLMJ8");
const $f32d54c244692341$export$1ba59dacbcbf90fe = ({ baseRoute: baseRoute })=>{
    const { navigationItems: navigationItems, isLoading: isLoading, teamId: teamId, dashboardId: dashboardId, isGlobal: isGlobal, error: error, hideItemsInSidebar: hideItemsInSidebar } = (0, $iZ8yx.useReportsController)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectedItemRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)((attributes)=>()=>{
            (0, $h8yj2.fireUIAnalytics)(createAnalyticsEvent({}), 'navigationItem clicked', 'opsReportsMenuItem', attributes);
        }, [
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const target = selectedItemRef.current;
        if (target) {
            // Target is outside the viewport from the bottom
            if (target.getBoundingClientRect().bottom > window.innerHeight) //  The bottom of the target will be aligned to the bottom of the visible area of the scrollable ancestor.
            target.scrollIntoView(false);
            // Target is outside the view from the top
            if (target.getBoundingClientRect().top < 0) // The top of the target will be aligned to the top of the visible area of the scrollable ancestor
            target.scrollIntoView();
        }
    }, [
        dashboardId
    ]);
    let component;
    if ((0, $gIuON.isServer)() || isLoading) component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null));
    else if (error || hideItemsInSidebar) component = null;
    else component = navigationItems.map((section, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
            title: section.name,
            key: index
        }, section.dashboards.map((menuItem)=>{
            const isSelected = dashboardId === menuItem.dashboardId;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSfqD.default), {
                ref: isSelected ? selectedItemRef : null,
                isSelected: isSelected,
                onClick: onClick({
                    selectedTeamId: teamId,
                    selectedDashboardId: menuItem.dashboardId,
                    isGlobal: isGlobal
                }),
                key: `${index}-${menuItem.dashboardId}`,
                href: `${baseRoute}/${menuItem.dashboardId}?selectedTeamId=${teamId}&global=${isGlobal}`,
                component: (0, $brUQK.LinkItem)
            }, menuItem.name);
        }));
    });
    return !!component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $XLMJ8.Container), null, navigationItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $ckGBu.SPOTLIGHT_NAMES).sidebarReportItems
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juVrZ.default), null, formatMessage((0, $eZtqT.default).header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        flexDirection: "column"
    }, component))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        flexDirection: "column"
    }, component)) : null;
};

});
parcelRegister("ckGBu", function(module, exports) {

$parcel$export(module.exports, "QUERY_PARAMS", () => $c8c6a702b10cb3c8$export$4a76520a6d4ed46b);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $c8c6a702b10cb3c8$export$a7c923252528b255);
$parcel$export(module.exports, "AVP_DASHBOARD_IDS", () => $c8c6a702b10cb3c8$export$84c93dd57f4f2ee);
$parcel$export(module.exports, "ENABLED_PRODUCTS", () => $c8c6a702b10cb3c8$export$8e7c951533a869b4);
$parcel$export(module.exports, "EMBED_TOKEN_EXPIRY_BUFFER", () => $c8c6a702b10cb3c8$export$97752b6d35b0d089);
var $c8c6a702b10cb3c8$export$4a76520a6d4ed46b = /*#__PURE__*/ function(QUERY_PARAMS) {
    QUERY_PARAMS["GLOBAL"] = "global";
    QUERY_PARAMS["SELECTED_TEAM_ID"] = "selectedTeamId";
    QUERY_PARAMS["AVP_QUERY_LOG"] = "querylog";
    return QUERY_PARAMS;
}({});
const $c8c6a702b10cb3c8$export$a7c923252528b255 = {
    sidebarReportItems: 'eoc-reports-sidenav'
};
const $c8c6a702b10cb3c8$export$ceeda9221026d51b = 'embed_ops_infrastructure_health_report';
const $c8c6a702b10cb3c8$export$84c93dd57f4f2ee = [
    $c8c6a702b10cb3c8$export$ceeda9221026d51b
];
const $c8c6a702b10cb3c8$export$8e7c951533a869b4 = {
    AVP: 'AVP',
    LOOKER: 'LOOKER'
};
const $c8c6a702b10cb3c8$export$97752b6d35b0d089 = 30000;

});

parcelRegister("iZ8yx", function(module, exports) {

$parcel$export(module.exports, "useReportsController", () => $a291e96e019bfc5f$export$c03d2280e03cf516);

var $bmKPg = parcelRequire("bmKPg");
var $ieDtd = parcelRequire("ieDtd");

var $hem2I = parcelRequire("hem2I");

var $ckGBu = parcelRequire("ckGBu");

var $dY89w = parcelRequire("dY89w");
const $a291e96e019bfc5f$export$c03d2280e03cf516 = ()=>{
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const [dashboardId] = (0, $bmKPg.usePathParam)('dashboardId');
    const [selectedTeamId] = (0, $ieDtd.useQueryParam)((0, $ckGBu.QUERY_PARAMS).SELECTED_TEAM_ID);
    const [global] = (0, $ieDtd.useQueryParam)((0, $ckGBu.QUERY_PARAMS).GLOBAL);
    const isGlobal = global === 'true';
    const permissionResource = (0, $hem2I.default)((0, $dY89w.opsReportsPermissionResource));
    const reportsResource = (0, $hem2I.default)((0, $dY89w.opsReportsResource));
    const isLoading = permissionResource.loading || reportsResource.loading;
    const error = permissionResource.error || reportsResource.error;
    let hideItemsInSidebar = false;
    let navigationItems = [];
    if (reportsResource.data) {
        const { settings: settings, dashboards: dashboards } = reportsResource.data;
        navigationItems = (isGlobal ? dashboards?.globalSpaces : dashboards?.teamSpaces) || [];
        hideItemsInSidebar = Boolean(settings?.showReportingMaintenance) || !navigationItems.length;
    }
    return {
        teamId: selectedTeamId || teamId,
        dashboardId: dashboardId,
        error: error,
        navigationItems: navigationItems,
        isGlobal: isGlobal,
        hideItemsInSidebar: hideItemsInSidebar,
        isLoading: isLoading
    };
};

});

parcelRegister("brUQK", function(module, exports) {

$parcel$export(module.exports, "LinkItem", () => $a19b4f2d451d1594$export$532cb6865ebe8946);

var $5uXOq = parcelRequire("5uXOq");

var $hDzhb = parcelRequire("hDzhb");
const $a19b4f2d451d1594$export$532cb6865ebe8946 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, onClick: onClick, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
        ref: ref,
        ...rest,
        onClick: onClick
    }, children);
});

});

parcelRegister("eZtqT", function(module, exports) {

$parcel$export(module.exports, "default", () => $788f992a5e96887e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $788f992a5e96887e$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        id: 'eoc.ops-reports-common.sidebar.header',
        defaultMessage: 'Reports',
        description: 'Header text'
    },
    underMaintenance: {
        id: 'eoc.ops-reports-common.sidebar.under-maintenance',
        defaultMessage: "Reports aren\u2019t available at this time",
        description: 'Text when reports are under maintenance'
    },
    errorIconLabel: {
        id: 'eoc.ops-reports-common.sidebar.error',
        defaultMessage: "Reports aren\u2019t available at this time",
        description: 'Text label for error icon'
    }
});
var $788f992a5e96887e$export$2e2bcd8739ae039 = $788f992a5e96887e$var$messages;

});

parcelRegister("XLMJ8", function(module, exports) {

$parcel$export(module.exports, "Container", () => $68a7fb25e2264b73$export$42a852a2b6b56249);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $68a7fb25e2264b73$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $68a7fb25e2264b73$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e18goy5b0"
})({
    name: "18trwji",
    styles: "margin-top:var(--ds-space-200, 16px)"
});

});


parcelRegister("cbdUv", function(module, exports) {

$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $dd972e7c34532966$export$a7c923252528b255);
const $dd972e7c34532966$export$a7c923252528b255 = {
    sidebarItems: 'eoc-team-dashboard_sidebar_items'
};

});

parcelRegister("3pkeM", function(module, exports) {

$parcel$export(module.exports, "Link", () => $3c63c09fc32d8730$export$a6c7ac8248d6e38a);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $h8yj2 = parcelRequire("h8yj2");

var $iGpTj = parcelRequire("iGpTj");
const $3c63c09fc32d8730$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { analyticsItemId: analyticsItemId, onClick: onClick, ...restProps } = props;
    const onClickWithAnalytics = (0, $5uXOq.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'sidebar', {
            itemId: analyticsItemId
        });
        onClick?.(e);
    }, [
        createAnalyticsEvent,
        analyticsItemId,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iGpTj.RouterLink), {
        ...restProps,
        onClick: onClickWithAnalytics,
        ref: ref,
        type: props.href != null || props.to != null ? 'a' : 'button',
        "aria-current": props.isSelected
    });
});

});
parcelRegister("iGpTj", function(module, exports) {

$parcel$export(module.exports, "RouterLink", () => $c1dd7e955688ba9b$export$fce709ebdac448ed);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hDzhb = parcelRequire("hDzhb");


var $bWGt6 = parcelRequire("bWGt6");
const $c1dd7e955688ba9b$export$fce709ebdac448ed = /*#__PURE__*/ (0, $bWGt6.default)((0, $hDzhb.default), {
    target: "e92oaog0"
})("[data-item-title]{line-height:1.2;color:", (props)=>props.isSelected ? "var(--ds-text, rgb(66, 82, 110))" : 'inherit', ";}& [data-item-title]{color:", (props)=>props.isSelected ? "var(--ds-text, rgb(66, 82, 110))" : 'inherit', ";}:focus,:visited,:active{position:relative;outline:0;text-decoration:inherit;}:active{background-color:", `var(--ds-background-selected-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`, ";box-shadow:var(--ds-shadow-overlay, transparent);& [data-item-title]{color:var(--ds-text, rgb(66, 82, 110));}}:focus{box-shadow:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`, " 0 0 0 2px inset;}");

});


parcelRegister("cxmrp", function(module, exports) {

$parcel$export(module.exports, "Header", () => $de89233a104eaab1$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ujWmd = parcelRequire("ujWmd");

var $fNobW = parcelRequire("fNobW");

var $juVrZ = parcelRequire("juVrZ");
var $bWqXX = parcelRequire("bWqXX");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");
var $gIuON = parcelRequire("gIuON");

var $hem2I = parcelRequire("hem2I");

var $2r8fH = parcelRequire("2r8fH");

var $5D8OW = parcelRequire("5D8OW");
const $de89233a104eaab1$export$8b251419efc915eb = ()=>{
    const { data: data, loading: loading, error: error, clear: clear } = (0, $hem2I.default)((0, $2r8fH.teamResource));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            clear();
        };
    }, [
        clear
    ]);
    if (loading || (0, $gIuON.isServer)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "eoc-team-dashboard-header-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
        hasIcon: true,
        isShimmering: true,
        testId: "loader"
    }));
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), {
        hasIcon: true,
        isShimmering: true,
        testId: "loader"
    });
    (0, $hmVmJ.assert)(!loading && !!data, new (0, $dH6Pi.AssertionError)('Sidebar', 'There was an error while fetching team information'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juVrZ.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            borderColor: "transparent",
            size: "small",
            src: data.avatarImageUrl
        }),
        description: formatMessage((0, $5D8OW.default).description)
    }, data.name);
};

});
parcelRegister("5D8OW", function(module, exports) {

$parcel$export(module.exports, "default", () => $717b8f6b79517969$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $717b8f6b79517969$var$messages = (0, $7VHMR.defineMessages)({
    description: {
        id: `eoc.team-dashboard.sidebar.header.description.no-translate`,
        defaultMessage: 'Operations',
        description: 'Description of project'
    }
});
var $717b8f6b79517969$export$2e2bcd8739ae039 = $717b8f6b79517969$var$messages;

});


parcelRegister("bvdmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $daf597b002907be4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $daf597b002907be4$var$messages = (0, $7VHMR.defineMessages)({
    sidebarLabel: {
        id: `eoc.team-dashboard.sidebar.label.no-translate`,
        defaultMessage: 'Operations Dashboard Navigation',
        description: 'Accessibility label of sidebar navigation'
    },
    description: {
        id: `eoc.team-dashboard.sidebar.description.no-translate`,
        defaultMessage: 'Operations',
        description: 'Description of project'
    },
    alerts: {
        id: `eoc.team-dashboard.sidebar.alerts.no-translate`,
        defaultMessage: 'Alerts',
        description: 'The label of menu item alerts'
    },
    reports: {
        id: `eoc.team-dashboard.sidebar.reports.no-translate`,
        defaultMessage: 'Reports',
        description: 'The label of menu item Reports'
    },
    onCall: {
        id: `eoc.team-dashboard.sidebar.on-call.no-translate`,
        defaultMessage: 'On-call',
        description: 'The label of menu item on-call'
    },
    integrations: {
        id: `eoc.team-dashboard.sidebar.integrations.no-translate`,
        defaultMessage: 'Integrations',
        description: 'The label of menu item integrations'
    },
    policies: {
        id: `eoc.team-dashboard.sidebar.policies.no-translate`,
        defaultMessage: 'Policies',
        description: 'The label of menu item policies'
    },
    automations: {
        id: `eoc.team-dashboard.sidebar.automations.no-translate`,
        defaultMessage: 'Automation',
        description: 'The label of menu item automations'
    },
    alertIssueSyncing: {
        id: `eoc.team-dashboard.sidebar.alertIssueSyncing.no-translate`,
        defaultMessage: 'Syncs',
        description: 'The label of menu item alertIssueSyncing'
    },
    settings: {
        id: `eoc.team-dashboard.sidebar.settings.no-translate`,
        defaultMessage: 'Member roles',
        description: 'The label of menu item ops settings'
    },
    heartbeats: {
        id: `eoc.team-dashboard.sidebar.heartbeats.no-translate`,
        defaultMessage: 'Heartbeats',
        description: 'The label of menu item called heartbeats'
    },
    maintenance: {
        id: `eoc.team-dashboard.sidebar.maintenance.no-translate`,
        defaultMessage: 'Maintenance',
        description: 'The label of menu item called maintenance'
    },
    giveFeedbackButton: {
        id: 'eoc.team-dashboard.sidebar.maintenance.no-translate',
        defaultMessage: 'Give feedback',
        description: 'Text of give feedback button'
    }
});
var $daf597b002907be4$export$2e2bcd8739ae039 = $daf597b002907be4$var$messages;

});

parcelRegister("4Vb0Z", function(module, exports) {

$parcel$export(module.exports, "SectionContainer", () => $f7223e62a7d164a1$export$be4c8679ebfd988);

var $bWGt6 = parcelRequire("bWGt6");
function $f7223e62a7d164a1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f7223e62a7d164a1$export$be4c8679ebfd988 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1a1h80h0"
})({
    name: "13ku56z",
    styles: "display:flex;flex-direction:column;height:100%"
});

});


parcelRegister("1Ucx1", function(module, exports) {

$parcel$export(module.exports, "useEocFeedbackCollector", () => $59465509708ed36e$export$6c2ca7ac39b8ab80);

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $doZTA = parcelRequire("doZTA");


var $hHSGg = parcelRequire("hHSGg");
const $59465509708ed36e$export$6c2ca7ac39b8ab80 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin, appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const [{ route: { name: name, path: path } }] = (0, $doZTA.useRouter)();
    return {
        openEocFeedbackCollector: (options)=>{
            openFeedbackCollector({
                showTypeField: false,
                feedbackTitle: formatMessage((0, $hHSGg.messages).modalTitle),
                summaryPlaceholder: formatMessage((0, $hHSGg.messages).feedbackInputPlaceholder),
                // @ts-expect-error: Object literal may only specify known properties, and 'customTextAreaLabel' does not exist in type 'FeedbackCollectorProps'.ts(2345)
                customTextAreaLabel: formatMessage((0, $hHSGg.messages).feedbackInputLabel),
                ...options,
                entrypointId: (0, $a4bb41a5178f4e2e$export$8c3fe078bd6c888e),
                onSubmit: ()=>{
                    // https://data-portal.internal.atlassian.com/analytics/registry/62661
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                        actionSubject: 'eocFeedbackCollectorModal',
                        action: 'submitted'
                    }));
                },
                feedbackContext: [
                    {
                        id: (0, $7iULw.EntryKeys).IS_ADMIN,
                        value: isAdmin
                    },
                    {
                        id: (0, $7iULw.EntryKeys).IS_SITE_ADMIN,
                        value: isSiteAdmin
                    },
                    {
                        id: (0, $7iULw.EntryKeys).EDITION,
                        value: appEditions.serviceDesk
                    },
                    {
                        id: (0, $7iULw.EntryKeys).ROUTE_NAME,
                        value: name
                    },
                    {
                        id: (0, $7iULw.EntryKeys).LOCATION,
                        value: path
                    }
                ]
            });
        }
    };
};

});
const $a4bb41a5178f4e2e$export$8c3fe078bd6c888e = '07551bfc-5486-4265-b9fa-7e540430b3fd';

parcelRegister("hHSGg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8fcc7b64d7376990$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8fcc7b64d7376990$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    modalTitle: {
        "id": "eoc-feedback-collector.modal-title",
        "defaultMessage": "Share your feedback with us"
    },
    feedbackInputPlaceholder: {
        "id": "eoc-feedback-collector.feedback-input-placeholder",
        "defaultMessage": "We'd love to know what you like, what you dislike, and what you want to change."
    },
    feedbackInputLabel: {
        "id": "eoc-feedback-collector.feedback-input-label",
        "defaultMessage": "Tell us what's on your mind"
    }
});

});


parcelRegister("2WDJ4", function(module, exports) {

$parcel$export(module.exports, "GlobalContextContainer", () => $cd75cd51f8698b39$export$8a0b5f75aa4dc446);

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $74BDp = parcelRequire("74BDp");
var $aI12f = parcelRequire("aI12f");

var $85qyr = parcelRequire("85qyr");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $pa9q9 = parcelRequire("pa9q9");

var $3HwlS = parcelRequire("3HwlS");

var $cfDZ3 = parcelRequire("cfDZ3");

var $lhVtI = parcelRequire("lhVtI");

var $fjcgS = parcelRequire("fjcgS");
const $cd75cd51f8698b39$var$addSearchPayload = (event)=>{
    try {
        const searchPayload = (0, $85qyr.addSearchSessionAttributes)();
        if (Object.keys(searchPayload).length > 0) // eslint-disable-next-line no-param-reassign
        event.payload.attributes = {
            ...event.payload.attributes,
            ...searchPayload
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('observability.analytics-providers-eoc.addSearchPayload', 'Failed to dynamically add search payload', e);
    }
    return event;
};
// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
const $cd75cd51f8698b39$var$sendAnalyticsEvent = (event)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>client.sendEvent(event));
};
// A custom listener to send events from analyticsBridge channel. Using the analytics bridge on AFE code
// creates events in this channel, which we can then listen here and send.
const $cd75cd51f8698b39$var$EocAnalyticsListener = ({ children: children })=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $cfDZ3.setSubProduct)('serviceDesk');
    }, []);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvUB1.default), {
        onEvent: (event)=>{
            // Mimic the behaviour on JFE, is this really necessary?
            const enrichedEvent = $cd75cd51f8698b39$var$addSearchPayload(event);
            $cd75cd51f8698b39$var$sendAnalyticsEvent((0, $lhVtI.getEvent)(enrichedEvent));
        },
        channel: "analyticsBridge"
    }, children);
};
const $cd75cd51f8698b39$export$8a0b5f75aa4dc446 = ({ children: children, packageName: packageName, teamName: teamName, config: config })=>{
    const flagService = (0, $pa9q9.useFlagService)();
    const isNewNavigation = (0, $3HwlS.getWillShowNav4)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $74BDp.GlobalContextContainer), {
        config: {
            ...config,
            isNewNavigation: isNewNavigation
        },
        flagService: flagService,
        reporter: ({ id: id, error: reporterError })=>{
            const error = (0, $aI12f.isHTTPError)(reporterError) ? new (0, $jJZqs.default)(reporterError.response.status, reporterError.message, reporterError.response.headers.get((0, $fnyT4.TRACE_ID_HEADER)) ?? undefined, reporterError.response) : reporterError;
            (0, $jcw0u.default)({
                meta: {
                    id: id,
                    packageName: packageName,
                    teamName: teamName
                },
                error: error
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cd75cd51f8698b39$var$EocAnalyticsListener, null, children));
};

});

parcelRegister("kHbhJ", function(module, exports) {

$parcel$export(module.exports, "ConsolidatedStateError", () => $0d2e3ee40ab3e7a9$export$1ce3e57a596218aa);

var $8J6rn = parcelRequire("8J6rn");
const $0d2e3ee40ab3e7a9$export$1ce3e57a596218aa = ()=>{
    const { shouldUseJSM: shouldUseJSM, error: error } = (0, $8J6rn.useOgTenantInfo)();
    if (error || !shouldUseJSM) {
        const consolidatedError = new Error('Not consolidated');
        consolidatedError.skipSentry = true;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const extendedError = error;
        if (extendedError) extendedError.skipSentry = true;
        throw extendedError || consolidatedError;
    }
    return null;
};

});

parcelRegister("dF4Di", function(module, exports) {

$parcel$export(module.exports, "ConsolidatedStateWrapper", () => $33187c8ccf842c7e$export$808758a1c9216c53);

var $5uXOq = parcelRequire("5uXOq");

var $beRD7 = parcelRequire("beRD7");

var $8J6rn = parcelRequire("8J6rn");

var $13f5b = parcelRequire("13f5b");
const $33187c8ccf842c7e$export$808758a1c9216c53 = ({ children: children, loadingComponent: loadingComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13f5b.ConsolidatedStateLoading), null), errorComponent: errorComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.NotFoundErrorPageAsync), null) })=>{
    const { shouldUseJSM: shouldUseJSM, loading: loading, error: error } = (0, $8J6rn.useOgTenantInfo)();
    if (loading) return loadingComponent;
    if (error || !shouldUseJSM) return errorComponent;
    return children;
};

});
parcelRegister("13f5b", function(module, exports) {

$parcel$export(module.exports, "ConsolidatedStateLoading", () => $b14022075e056ba2$export$bde5b6095281f205);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");

var $eZJjh = parcelRequire("eZJjh");
const $b14022075e056ba2$export$bde5b6095281f205 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));

});





//# sourceMappingURL=async-sidebar-team-dashboard.5c0cf51a.js.map
